/*
@license
  Be Yours by roartheme (https://roartheme.co)
  Access unminified JS in assets/global.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://roartheme.co/blogs/beyours/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
window.theme = window.theme || {};

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: 'screen and (max-width: 749px)',
  mediaQueryProductMobile: 'screen and (max-width: 749px), screen and (max-width: 1199px) and (orientation: portrait)',
  mediaQueryProductDesktop: 'screen and (min-width: 1200px), screen and (min-width: 750px) and (orientation: landscape)',
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  rtl: document.documentElement.getAttribute('dir') === 'rtl' ? true : false,
  // iPadOS 13+ reports as Macintosh; maxTouchPoints is the remaining signal.
  isAppleTouch: /iP(hone|ad|od)/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1)
};

theme.Currency = (function() {
  const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function formatMoneyWithoutTrailingZeros(cents, format) {
    const formatted = formatMoney(cents, format);
    const normalizedCents = typeof cents === 'string'
      ? Number(cents.replace('.', ''))
      : Number(cents);

    if (
      (theme.shopSettings && theme.shopSettings.currencyCode) ||
      !Number.isFinite(normalizedCents) ||
      Math.abs(normalizedCents % 100) !== 0
    ) {
      return formatted;
    }

    return formatted.replace(/([.,])00(?=\s*[^0-9]*$)/, '');
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    formatMoneyWithoutTrailingZeros: formatMoneyWithoutTrailingZeros,
    getBaseUnit: getBaseUnit
  };
})();

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});

  observer.observe(options.element);
};

// Open external link in new tab
(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname && links[i].getAttribute('href').startsWith('http')) {
      links[i].target = '_blank';
    }
  }
})();

(function() {
  const skeepersReviewCountSelector = '.skeepers_product__stars .rate-total';
  let normalizeScheduled = false;

  function normalizeSkeepersReviewCounts(root = document) {
    root.querySelectorAll(skeepersReviewCountSelector).forEach((rateTotal) => {
      const count = rateTotal.textContent.trim().match(/\d+/)?.[0];
      if (!count) return;

      if (rateTotal.textContent.trim() !== count) {
        rateTotal.textContent = count;
      }
    });
  }

  function scheduleNormalizeSkeepersReviewCounts() {
    if (normalizeScheduled) return;

    normalizeScheduled = true;
    window.requestAnimationFrame(() => {
      normalizeScheduled = false;
      normalizeSkeepersReviewCounts();
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    normalizeSkeepersReviewCounts();

    const observer = new MutationObserver((mutations) => {
      const shouldNormalize = mutations.some((mutation) => {
        const target = mutation.target;
        if (target.nodeType === Node.TEXT_NODE) {
          return target.parentElement && target.parentElement.closest(skeepersReviewCountSelector);
        }

        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return node.matches(skeepersReviewCountSelector) || node.querySelector(skeepersReviewCountSelector);
        });
      });

      if (shouldNormalize) {
        scheduleNormalizeSkeepersReviewCounts();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });

  document.addEventListener('productInfo:loaded', () => normalizeSkeepersReviewCounts());
})();

(function() {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall);
  theme.config.mqlSmall = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.mqlSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  }

  // Page transition
  window.addEventListener('beforeunload', () => {
    document.body.classList.add('unloading');
  });
  window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('loaded');

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });
  window.addEventListener('pageshow', (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove('unloading');
    }
  });

  // iOS zoom-on-input-focus is handled by an inline script in theme.liquid's
  // head. It has to run before first paint — rewriting the viewport meta here on
  // DOMContentLoaded made Safari re-apply the initial scale and reset the scroll
  // position, and it also dropped viewport-fit=cover.

  // Viewport height
  function viewportHeight() {
    if (window.matchMedia('(max-width: 990px)')) {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    setHeaderBottomPosition();
    setHeaderHeight();
  }
  window.addEventListener('resize', viewportHeight);
  window.addEventListener('DOMContentLoaded', viewportHeight);

  if (document.body.getAttribute('data-page-rendering') !== null) {
    // Improve initial load time by skipping the rendering of offscreen content
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          const el = entry.target;
          // Not currently in intersection area.
          if (entry.intersectionRatio == 0) {
            return;
          }
          // Trigger rendering for elements within scroll area that haven't already been marked.
          if (!el.markedVisible) {
            el.attributeStyleMap && el.attributeStyleMap.set('content-visibility', 'visible');
            el.markedVisible = true;
          }
        });
      },
      // Set a rendering 50px above and 100px below the main scroll area.
      { rootMargin: '50px 0px 100px 0px' }
    );
    const sections = document.querySelectorAll('.shopify-section + .shopify-section');
    sections.forEach((section) => { observer.observe(section); });
  }

  /*
  // Delay JavaScript until user interaction
  const loadScriptsTimer = setTimeout(loadScripts, 5000);
  const userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"];
  userInteractionEvents.forEach(function(event) {
    window.addEventListener(event, triggerScriptLoader, {
      passive: !0
    });
  });
  function triggerScriptLoader() {
    loadScripts();
    clearTimeout(loadScriptsTimer);
    userInteractionEvents.forEach(function(event) {
      window.removeEventListener(event, triggerScriptLoader, {
        passive: !0
      });
    });
  }
  function loadScripts() {
    document.querySelectorAll("script[data-type='lazy']").forEach(function(script) {
      script.setAttribute("src", script.getAttribute("data-src"));
    });
  }
  */
})();

// Prevent vertical scroll while using flickity sliders
(function() {
  var e = !1;
  var t;

  document.body.addEventListener('touchstart', function(i) {
    if (!i.target.closest('.flickity-slider')) {
      return e = !1;
    }
    e = !0;
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY
    }
  })

  document.body.addEventListener('touchmove', function(i) {
    if (e && i.cancelable) {
      var n = {
        x: i.touches[0].pageX - t.x,
        y: i.touches[0].pageY - t.y
      };
      Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
    }
  }, { passive: !1 })
})();

function isStorageSupported (type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = 'beyours:test';
  let storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  }
  catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}

function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement('span');
    element.className = 'modal-scrollbar-measure', document.body.appendChild(element);
  
    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }
}

function setRootPxIfChanged(name, px) {
  const next = Math.round(px);
  if (!Number.isFinite(next) || next < 0) return;
  const current = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name));
  if (Number.isFinite(current) && Math.abs(current - next) <= 2) return;
  document.documentElement.style.setProperty(name, `${next}px`);
}

function setHeaderBottomPosition() {
  const header = document.querySelector('.shopify-section-header');
  if (!header) return;

  // Layout heights, not getBoundingClientRect().bottom: that value is
  // viewport-relative and jumps when the header becomes sticky/fixed or
  // when iOS Safari fires resize as the toolbar shows and hides. Hero
  // copy uses this var for padding, so a live rect makes it saccade.
  const announcement = document.querySelector('.shopify-section-announcement-bar');
  const announcementHeight = announcement && announcement.offsetParent !== null
    ? announcement.offsetHeight
    : 0;
  setRootPxIfChanged('--header-bottom-position', announcementHeight + header.offsetHeight);
}

function setHeaderHeight() {
  const header = document.querySelector('.shopify-section-header');
  if (header) {
    setRootPxIfChanged('--header-height', header.offsetHeight);
  }
}

// iOS Safari edge bands are the sticky header compositor layer. Reset it
// while a drawer is open, then put it back on close without the reveal
// animation (a transform at the Safari edge is the leftover).
let stickyParkCount = 0;
let parkedStickyHeader = null;

function parkStickyHeaderForDrawer() {
  if (!theme.config.isAppleTouch) return;

  stickyParkCount += 1;
  if (stickyParkCount > 1) return;

  const sticky = document.querySelector('sticky-header');
  if (!sticky || typeof sticky.sticky !== 'function' || typeof sticky.reset !== 'function') return;

  parkedStickyHeader = sticky.sticky();
  if (parkedStickyHeader) sticky.reset();
}

function restoreStickyHeaderAfterDrawer() {
  if (!theme.config.isAppleTouch) return;

  stickyParkCount = Math.max(0, stickyParkCount - 1);
  if (stickyParkCount > 0) return;

  const wasSticky = parkedStickyHeader;
  parkedStickyHeader = null;
  if (!wasSticky) return;

  const sticky = document.querySelector('sticky-header');
  if (!sticky || typeof sticky.stick !== 'function' || !sticky.header) return;

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (typeof sticky.atPageTop === 'function' && sticky.atPageTop(scrollTop)) return;

  sticky.stick();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'TAB') return; // If not TAB key
    
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus({ preventScroll: true });

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('video-section[data-type="youtube"]:not([data-video-hero]) iframe').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('video-section[data-type="vimeo"]:not([data-video-hero]) iframe').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (!video.closest('[data-video-hero]')) video.pause();
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus({ preventScroll: true });
}

function onKeyUpEscape(event) {
  const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
  if (charCode !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes('shopify:section')) {
    if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) {
      executeCallback = true;
    }
  }
  else if (event.type.includes('shopify:block') && event.target === domElement) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) { 
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/*
 * Product card image sources.
 *
 * card-product.liquid renders each colour-swatch and deferred gallery image as
 * one width-less CDN URL; the src/srcset pairs are built here when a swatch or
 * gallery is used. Rendering a full srcset for every colour and slide made each
 * collection card ~18 KB heavier. The strings built here are exactly what the
 * Liquid used to output, so the browser keeps picking the same file.
 */
const cardMedia = {
  // colour swatch srcset candidates (plus the original file at its own width):
  // the card image's own image_tag widths, so the swatch prefetch of the current
  // colour and a tap back on it reuse the file the card already downloaded. With
  // the old 533/720/1066 set the same image was downloaded twice.
  swatchWidths: [165, 360, 535, 750, 940, 1100],
  swatchSrcWidth: 535,

  sizedUrl(url, width) {
    return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
  },

  swatchImage(url, originalWidth) {
    if (!url) return { src: '', srcset: '' };

    const width = parseInt(originalWidth, 10) || 0;
    const candidates = cardMedia.swatchWidths
      .filter((candidate) => width >= candidate)
      .map((candidate) => `${cardMedia.sizedUrl(url, candidate)} ${candidate}w`);
    candidates.push(`${url} ${width}w`);

    return { src: cardMedia.sizedUrl(url, cardMedia.swatchSrcWidth), srcset: candidates.join(',') };
  },

  swatchPrimary(swatch) {
    return cardMedia.swatchImage(swatch.dataset.mediaUrl, swatch.dataset.mediaWidth);
  },

  // a swatch without its own second image shows its primary one there
  swatchHover(swatch) {
    return swatch.dataset.hoverMediaUrl
      ? cardMedia.swatchImage(swatch.dataset.hoverMediaUrl, swatch.dataset.hoverMediaWidth)
      : cardMedia.swatchPrimary(swatch);
  },

  // the card gallery slides for one colour: primary, second image, extras
  swatchGalleryItems(swatch) {
    const items = [];
    if (!swatch) return items;

    const title = swatch.getAttribute('title') || '';
    const primaryUrl = swatch.dataset.mediaUrl || '';
    if (primaryUrl) {
      items.push({ ...cardMedia.swatchPrimary(swatch), alt: title, ratio: parseFloat(swatch.dataset.aspectRatio || '0') });
    }

    const hoverUrl = swatch.dataset.hoverMediaUrl || '';
    if (hoverUrl && hoverUrl !== primaryUrl) {
      items.push({ ...cardMedia.swatchHover(swatch), alt: title, ratio: parseFloat(swatch.dataset.hoverAspectRatio || '0') });
    }

    const extraUrls = (swatch.dataset.galleryExtraUrls || '').split('||').filter(Boolean);
    const extraWidths = (swatch.dataset.galleryExtraWidths || '').split('||');
    const extraAlts = (swatch.dataset.galleryExtraAlts || '').split('||');
    const extraRatios = (swatch.dataset.galleryExtraAspectRatios || '').split('||');

    extraUrls.forEach((url, index) => {
      items.push({
        ...cardMedia.swatchImage(url, extraWidths[index]),
        alt: extraAlts[index] || title,
        ratio: parseFloat(extraRatios[index] || '0')
      });
    });

    return items;
  },

  // srcset of a deferred gallery slide, in image_tag's format: `src` is the
  // slide's own URL, `widths` the image_tag widths rendered on its gallery
  imageTagSrcset(src, widths) {
    const url = src.replace(/[?&]width=\d+$/, '');
    return widths
      .split(',')
      .map((width) => width.trim())
      .filter(Boolean)
      .map((width) => `${cardMedia.sizedUrl(url, width)} ${width}w`)
      .join(', ');
  }
};

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.postLink2 = function(path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    for (const index in params[key]) {
      for (const key2 in params[key][index]) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", `${key}[${index}][${key2}]`);
        hiddenField.setAttribute("value", params[key][index][key2]);
        form.appendChild(hiddenField);
      }
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class ViewMoreButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.button-view-more');
    this.buttonTextMore = this.button.innerHTML;
    this.buttonTextLess = this.button.dataset.textLess;
    this.collapsibles = document.getElementById(this.getAttribute('aria-controls'));
    this.init();
  }

  init() {
    this.collapsibles.setAttribute('aria-expanded', false);
    this.button.addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    this.collapsibles.setAttribute(
      'aria-expanded',
      (this.collapsibles.getAttribute('aria-expanded') === 'false').toString()
    );
    if(this.collapsibles.getAttribute('aria-expanded') === 'false') {
      this.button.textContent = this.buttonTextMore;
    } else {
      this.button.textContent = this.buttonTextLess;
    }
  }
}
customElements.define('view-more-button', ViewMoreButton);

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.addEventListener('focus', this.onInputFocus.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  onInputFocus() {
    this.input.select();
  }
}
customElements.define('quantity-input', QuantityInput);

class DrawerCloseButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => this.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true, cancelable: true, composed: true })));
  }
}
customElements.define('drawer-close-button', DrawerCloseButton);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      open: 'menu-drawer--open',
      opening: 'menu-drawer--opening',
      closing: 'menu-drawer--closing'
    };
    this.animationToken = 0;

    this.mainDetailsToggle = this.querySelector('details');
    this.holdsStickyPark = false;

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  disconnectedCallback() {
    if (!this.holdsStickyPark) return;
    this.holdsStickyPark = false;
    restoreStickyHeaderAfterDrawer();
  }

  setClasses(classes) {
    this.classes = classes;
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button[data-close]').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

    this.addEventListener('drawer:force-close', (event) => {
      event.stopPropagation();
      this.closeMenuDrawer(event);
    });
  }

  onKeyUp(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
  if (charCode !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      if(detailsElement.querySelector('button')) {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      }
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement = false) {
    setScrollbarWidth();
    setHeaderBottomPosition();
    if (!this.holdsStickyPark) {
      this.holdsStickyPark = true;
      parkStickyHeaderForDrawer();
    }
    const animationToken = ++this.animationToken;

    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    setTimeout(() => {
      if (animationToken !== this.animationToken) return;
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener('click', this.onBodyClickEvent);
    });
    this.mainDetailsToggle.classList.remove('menu-closing');
    document.body.classList.remove(this.classes.closing);
    document.body.classList.add(this.classes.opening);

    this.openAnimation(animationToken);
    setTimeout(() => {
      if (animationToken !== this.animationToken) return;
      this.mainDetailsToggle.setAttribute('open', '');
      setTimeout(() => {
        if (animationToken !== this.animationToken) return;
        this.mainDetailsToggle.classList.add('menu-opening');
      }, 10);
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.classList.add('menu-closing');
      removeTrapFocus(elementToFocus);
      
      document.body.removeEventListener('click', this.onBodyClickEvent);
      const animationToken = ++this.animationToken;
      document.body.classList.remove(this.classes.open, this.classes.opening);
      document.body.classList.add(this.classes.closing);
      
      this.closeAnimation(this.mainDetailsToggle, animationToken);
      this.dispatchEvent(new CustomEvent('close'));
      document.dispatchEvent(new CustomEvent('menudrawer:close'));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const target = event.currentTarget;
    if (target.classList.contains('noclose')) return;
    
    const detailsElement = target.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  openAnimation(animationToken) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationToken !== this.animationToken) return;

      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      }
      else {
        if (animationToken !== this.animationToken) return;
        document.body.classList.remove(this.classes.opening);
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.classList.contains('menu-closing')) {
          document.body.classList.add(this.classes.open);
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  closeAnimation(detailsElement, animationToken = null) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationToken !== null && animationToken !== this.animationToken) return;

      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      }
      else {
        if (detailsElement === this.mainDetailsToggle) {
          if (animationToken !== null && animationToken !== this.animationToken) return;
          document.body.classList.remove(this.classes.open, this.classes.opening, this.classes.closing);
          detailsElement.classList.remove('menu-closing');
          if (this.holdsStickyPark) {
            this.holdsStickyPark = false;
            restoreStickyHeaderAfterDrawer();
          }
        }
        detailsElement.removeAttribute('open');

        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.closeMenuDrawer(event);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class CartDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'mini-cart--open',
      opening: 'mini-cart--opening',
      closing: 'mini-cart--closing'
    });
  }
}
customElements.define('cart-drawer', CartDrawer);

class FacetDrawer extends MenuDrawer {
  constructor() {
    super();

    if (this.dataset.desktop == 'true') {
      this.setClasses({
        open: 'facet-horizontal--open',
        opening: 'facet-horizontal--opening',
        closing: 'facet-horizontal--closing'
      });
    }
    else {
      this.setClasses({
        open: 'facet-drawer--open',
        opening: 'facet-drawer--opening',
        closing: 'facet-drawer--closing'
      });
    }
  }
}
customElements.define('facet-drawer', FacetDrawer);

class HeaderDrawer extends MenuDrawer {
  openMenuDrawer(summaryElement = false) {
    this.querySelectorAll('details[data-default-open]').forEach((details) => {
      details.open = true;
      details.classList.add('menu-opening');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    });
    super.openMenuDrawer(summaryElement);
  }

  constructor() {
    super();

    this.setClasses({
      open: 'menu-mobile--open',
      opening: 'menu-mobile--opening',
      closing: 'menu-mobile--closing'
    });
  }
}
customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
      if (charCode === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    setScrollbarWidth();
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(this.button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!this.poster) return;

    this.poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);

      if (content.querySelector('video-section')) {
        const deferredElement = this.appendChild(content);
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      } else {
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

// Slider counters update on every scroll event; assigning textContent always
// replaces the text node and dirties style even when the number is unchanged.
function setTextIfChanged(element, value) {
  if (!element) return;
  const text = String(value);
  if (element.textContent !== text) element.textContent = text;
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dots = this.querySelector('[id^="SliderDots-"]');
    this.isDraggable = this.getAttribute('data-draggable') || false;
    this.autoScroll = this.getAttribute("data-autoscroll") || false;

    if (!this.slider) return;
    if (!this.nextButton && !this.dots && !this.isDraggable && !this.autoScroll) return;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    if(this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
    if (this.dots) this.dots.addEventListener('click', this.onDotsClick.bind(this));

    if (this.isDraggable) this.initDrag();

    if (this.autoScroll) this.initScroll();
  }

  get items() {
    return this._items = this._items || Array.from(this.sliderItems);
  }

  get itemsToShow() {
    return Array.from(this.items).filter(element => element.clientWidth > 0);
  }

  get sliderItemOffset() {
    return this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
  }

  get slidesPerPage() {
    return Math.floor(this.slider.clientWidth / this.sliderItemOffset);
  }

  get totalPages() {
    return this.itemsToShow.length - this.slidesPerPage + 1;
  }

  initPages() {
    if (this.itemsToShow.length < 2) return;
    this.update();
  }

  resetPages() {
    // re-query: prepends (variant featured media) change DOM order and the
    // static NodeList from the constructor goes stale, desyncing itemsToShow
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this._items = Array.from(this.sliderItems);
    this.resetScrollPosition();
    this.initPages();
  }

  select(selectedIndex) {
    this.scrollPosition = this.slider.scrollLeft - (this.currentPage - selectedIndex) * this.sliderItemOffset * (theme.config.rtl ? -1 : 1);
    this.slider.scrollTo({
      left: this.scrollPosition
    });
  }

  selected(selectedIndex) {
    return this.itemsToShow[selectedIndex];
  }

  update() {
    if (this.itemsToShow.length < 2) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      setTextIfChanged(this.currentPageElement, this.currentPage);
      setTextIfChanged(this.pageTotalElement, this.totalPages);
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.itemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.currentPage === 1 && this.currentPage === this.totalPages) {
      this.classList.add('slider--no-buttons');
    } else {
      this.classList.remove('slider--no-buttons');
    }

    if (this.enableSliderLooping) return;

    if (!this.nextButton) return;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.itemsToShow.length;

    if (isFirstSlide || this.isSlideVisible(this.itemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (isLastSlide || this.isSlideVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    //this.slideScrollPosition = theme.config.rtl ? this.slideScrollPosition * -1 : this.slideScrollPosition;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  onDotsClick(event) {
    event.preventDefault();

    const li = event.target.closest('li');
    if (!li || !this.dots.contains(li) || li.classList.contains('hidden')) return;

    const lis = Array.from(this.dots.querySelectorAll('li:not(.hidden)'));
    const index = lis.indexOf(li) + 1;

    if (!index) return;

    const step = (index > this.currentPage) ? index - this.currentPage : this.currentPage - index;

    this.slideScrollPosition = (index > this.currentPage) ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slideScrollPosition = theme.config.rtl ? this.slideScrollPosition * -1 : this.slideScrollPosition;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
    
  }

  initDrag() {
    if (theme.config.mqlSmall) return;
    this.isDragging = false;
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    const mousePosition = { x: 0, y: 0 };
    const speedFactor = 1.5;

    const onMouseDown = (e) => {
      isDown = true;
      // Prevent text/image selection during active drag
      e.preventDefault();

      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
      mousePosition.x = e.screenX;
      mousePosition.y = e.screenY;

      // Listen on window to support smooth dragging even if cursor leaves the element boundaries
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    };

    const onMouseMove = (e) => {
      if (!isDown) return;

      // Prevent triggering drag on simple clicks with negligible move
      if (mousePosition.x === e.screenX && mousePosition.y === e.screenY) return;

      e.preventDefault();
      this.classList.add('is-dragging');
      this.isDragging = true;

      const x = e.pageX - this.slider.offsetLeft;
      // Handle Right-to-Left (RTL) scroll direction correctly if enabled in theme config
      const rtlMultiplier = theme.config.rtl ? -1 : 1;
      const walk = (x - startX) * speedFactor * rtlMultiplier;
      const nextScrollLeft = scrollLeft - walk;
      if (this._desktopLoop) {
        scrollLeft += this.normalizeDesktopLoop(nextScrollLeft);
      } else {
        this.slider.scrollLeft = nextScrollLeft;
      }
    };

    const onMouseUp = () => {
      if (!isDown) return;
      isDown = false;

      // Delay resetting isDragging so the capture-phase click handler can catch and prevent accidental clicks
      setTimeout(() => {
        this.isDragging = false;
      }, 0);

      this.classList.remove('is-dragging');

      // Clean up dynamic window event listeners
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    this.slider.addEventListener('mousedown', onMouseDown);

    // Prevent navigation/clicks on elements inside the slider when dragging occurs
    this.slider.addEventListener('click', (e) => {
      if (this.isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true); // Use capturing phase to intercept clicks before child listeners receive them
  }

  initScroll() {
    if (!this.slider || this.isScrolling) return;
    if (theme.config.mqlSmall) return;
    
    // Use IntersectionObserver to play/pause autoscroll based on viewport visibility
    if (!this.scrollObserver) {
      this.scrollObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        }, { rootMargin: "0px 0px 50px 0px" }
      );
      this.scrollObserver.observe(this.slider);
    }

    if (!this.scrollAnimationFrameId) {
      this.scrollingPlay();
    }

    // Bind event handlers once to preserve reference for cleanup
    if (!this.onSliderMouseMove) {
      this.onSliderMouseMove = () => {
        if (this.isDragging) this.scrollingPause();
      };
    }
    if (!this.onSliderFocus) {
      this.onSliderFocus = () => this.scrollingPause();
    }
    if (!this.onSliderBlur) {
      this.onSliderBlur = () => this.scrollingPlay();
    }
    if (!this.onSliderTouchStart) {
      this.onSliderTouchStart = () => this.scrollingPause();
    }

    // Register listeners if not already attached
    if (!this.scrollEventsAttached) {
      this.slider.addEventListener("mousemove", this.onSliderMouseMove);
      this.slider.addEventListener('focus', this.onSliderFocus, true);
      this.slider.addEventListener('blur', this.onSliderBlur, true);
      this.slider.addEventListener('touchstart', this.onSliderTouchStart, { passive: true });
      this.scrollEventsAttached = true;
    }

    if (!this.onWindowResize) {
      this.onWindowResize = debounce(() => {
        if (theme.config.mqlSmall) {
          this.destroyScroll();
        } else {
          this.initScroll();
        }
      }, 200);
      window.addEventListener("resize", this.onWindowResize);
    }
  }

  resetScrollPosition() {
    if (!this.slider || !this.autoScroll) return;
    this.destroyScroll();
    
    const originalScrollBehavior = this.slider.style.scrollBehavior;
    this.slider.style.scrollBehavior = 'auto';
    this.slider.scrollTo({ left: 0 });
    this.slider.style.scrollBehavior = originalScrollBehavior;

    setTimeout(() => {
      this.initScroll();
    }, 300);
  }

  destroyScroll() {
    this.scrollingPause();

    // Clean up IntersectionObserver
    if (this.scrollObserver) {
      this.scrollObserver.disconnect();
      this.scrollObserver = null;
    }

    // Clean up Event Listeners
    if (this.scrollEventsAttached) {
      this.slider.removeEventListener('mousemove', this.onSliderMouseMove);
      this.slider.removeEventListener('focus', this.onSliderFocus, true);
      this.slider.removeEventListener('blur', this.onSliderBlur, true);
      this.slider.removeEventListener('touchstart', this.onSliderTouchStart, { passive: true });
      this.scrollEventsAttached = false;
    }
  }

  scrollingPlay() {
    if (!this.slider || this.isDragging) return;
    this.scrollingPause(); // Ensure any existing animation loop is stopped
    this.prepareAutoScrollStyles();

    this.isScrolling = true;
    const pixelsPerMillisecond = 0.04;
    let lastTimestamp = null;
    let scrollPosition = this.slider.scrollLeft;

    const scrollStep = (timestamp) => {
      if (!this.isScrolling || !this.slider) return;

      if (!lastTimestamp) {
        lastTimestamp = timestamp;
      }
      const elapsed = timestamp - lastTimestamp;
      lastTimestamp = timestamp;

      // Prevent division/multiplication issues if frame time is extremely large
      const safeElapsed = Math.min(elapsed, 100);

      const direction = theme.config.rtl ? -1 : 1;
      const delta = safeElapsed * pixelsPerMillisecond * direction;
      scrollPosition += delta;

      this.slider.scrollLeft = scrollPosition;
      if (this.normalizeDesktopLoop) {
        scrollPosition += this.normalizeDesktopLoop();
      }

      // Sub-pixel tolerant check for reaching the end of the scrollable area
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const currentScroll = Math.abs(this.slider.scrollLeft);

      if (Math.ceil(currentScroll) >= maxScroll - 1) {
        if (this.enableSliderLooping && maxScroll > 0 && typeof this.goToFirstSlide === 'function') {
          this.goToFirstSlide({ behavior: 'auto' });
          scrollPosition = this.slider.scrollLeft;
          lastTimestamp = null;
          this.scrollAnimationFrameId = requestAnimationFrame(scrollStep);
        } else {
          this.scrollingPause();
        }
      } else {
        this.scrollAnimationFrameId = requestAnimationFrame(scrollStep);
      }
    };

    this.scrollAnimationFrameId = requestAnimationFrame(scrollStep);
  }

  prepareAutoScrollStyles() {
    if (!this.slider || this.autoScrollStyles) return;

    this.autoScrollStyles = {
      scrollBehavior: this.slider.style.scrollBehavior,
      scrollSnapType: this.slider.style.scrollSnapType
    };

    this.slider.style.scrollBehavior = 'auto';
    this.slider.style.scrollSnapType = 'none';
  }

  restoreAutoScrollStyles() {
    if (!this.slider || !this.autoScrollStyles) return;

    this.slider.style.scrollBehavior = this.autoScrollStyles.scrollBehavior;
    this.slider.style.scrollSnapType = this.autoScrollStyles.scrollSnapType;
    this.autoScrollStyles = null;
  }

  scrollingPause() {
    if (this.scrollAnimationFrameId) {
      cancelAnimationFrame(this.scrollAnimationFrameId);
      this.scrollAnimationFrameId = null;
    }
    this.isScrolling = false;
    this.restoreAutoScrollStyles();
  }

  disconnectedCallback() {
     // Ensure observers/listeners created by autoscroll don't outlive the element
     this.destroyScroll();
     if (this.onWindowResize) {
       window.removeEventListener('resize', this.onWindowResize);
       this.onWindowResize = null;
     }
   }
}
customElements.define('slider-component', SliderComponent);

class SliderScrollComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="SliderScroll-"]');
    this.sliderItems = this.querySelectorAll('[id^="SlideScroll-"]');
    this.mouseDown = false;
    this.scrollInterval = null;

    theme.initWhenVisible({
      element: this,
      callback: this.initEvents.bind(this),
      threshold: 200
    });
  }

  initEvents() {
    this.resizeObserver = new ResizeObserver(() => this.init());
    this.resizeObserver.observe(this.slider);

    this.visibilityObserver = new IntersectionObserver(([entry]) => {
      this.isInViewport = entry.isIntersecting;
      if (!entry.isIntersecting) {
        this.stopScrollInterval();
      } else if (this.isScrolling) {
        this.initScroll();
      }
    });
    this.visibilityObserver.observe(this.slider);

    this.slider.addEventListener('touchmove', this.pauseAutoScroll.bind(this));
    this.slider.addEventListener('mouseover', this.pauseAutoScroll.bind(this));
    this.slider.addEventListener('mouseout', this.resumeAutoScroll.bind(this));

    this.slider.addEventListener('mousemove', this.dragMove.bind(this));
    this.slider.addEventListener('mousedown', this.dragStart.bind(this));
    this.slider.addEventListener('mouseup', this.dragStop.bind(this));
    this.slider.addEventListener('mouseleave', this.dragStop.bind(this));
    this.slider.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
  }

  init() {
    this.isScrolling = false;
    this.isDraggable = false;
    this.slider.removeAttribute('draggable', true);

    if(this.slider.scrollWidth <= this.slider.clientWidth) {
      this.stopScrollInterval();
      return;
    }
    this.isScrolling = true;
    this.isDraggable = true;
    this.slider.setAttribute('draggable', true);
    this.initScroll();
  }
  
  dragStart(e) {
    if(!this.isDraggable) return;
    e.preventDefault();
    this.mouseDown = true;
    this.isScrolling = false;
    this.slider.classList.add('active');
    this.startX = e.pageX - this.slider.offsetLeft;
    this.sliderScrollLeft = this.slider.scrollLeft;
  }

  dragStop(e) {
    this.mouseDown = false;
    this.slider.classList.remove('active');
  }

  dragMove(e) {
    if(!this.mouseDown || !this.isDraggable) { return; }
    e.preventDefault();
    const x = e.pageX - this.slider.offsetLeft;
    const scroll = (x - this.startX) * 2;
    this.slider.scrollLeft = this.sliderScrollLeft - scroll;
  }

  onWheel(e) {
    const wheelDelta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
    if(!wheelDelta || !this.isDraggable) return;

    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    if(maxScroll <= 0) return;

    const nextScroll = Math.max(0, Math.min(maxScroll, this.slider.scrollLeft + wheelDelta));
    if(nextScroll === this.slider.scrollLeft) return;

    e.preventDefault();
    this.pauseAutoScroll();
    this.slider.scrollLeft = nextScroll;
  }

  stopScrollInterval() {
    if(this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
  }

  initScroll() {
    this.stopScrollInterval();
    if (this.isInViewport === false) return;
    this.scrollInterval = setInterval(() => {
      if(!this.isScrolling) return;
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      this.slider.scrollLeft = Math.min(this.slider.scrollLeft + 1, maxScroll);
      if(this.slider.scrollLeft >= maxScroll) {
        this.pauseAutoScroll();
      }
    }, 15);
  }

  pauseAutoScroll() {
    this.isScrolling = false;
  }

  resumeAutoScroll() {
    if(this.slider.scrollWidth <= this.slider.clientWidth) return;
    this.isScrolling = true;
    if(!this.scrollInterval) this.initScroll();
  }

  disconnectedCallback() {
    this.stopScrollInterval();
    this.resizeObserver?.disconnect();
    this.visibilityObserver?.disconnect();
  }
}
customElements.define('slider-scroll-component', SliderScrollComponent);

class ThumbnailSlider extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const variantItems = this.querySelectorAll('.thumbnail-list_item--variant:not(.is-active)');
    this.slider.dataset.mediaCount = this.sliderItems.length - variantItems.length;

    if(this.querySelector('[data-gang-option]')) {
      const inactiveGangItems = this.querySelectorAll('[data-gang-option]:not(.gang__active)');
      this.slider.dataset.mediaCount = this.sliderItems.length - inactiveGangItems.length;
    }

    if (this.slider.dataset.mediaCount < 2) this.classList.add('hidden');
  }
}
customElements.define('thumbnail-slider', ThumbnailSlider);

class QuoteSlider extends SliderComponent {
  constructor() {
    super();
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      this.sliderItems.forEach((element) => {
        element.removeAttribute('aria-current');
      });

      const currentElement = this.itemsToShow[this.currentPage - 1];
      currentElement.setAttribute('aria-current', true);
    }
  }
}
customElements.define('quote-slider', QuoteSlider);

class ProductGallery extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = false;

    if (this.slider && (!this.nextButton || !this.dots)) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 200
      });
    }
  }

  initScroll() {
    if (window.matchMedia(theme.config.mediaQueryProductMobile).matches) {
      this.destroyScroll();
      return;
    }
    super.initScroll();
  }

  init() {
    if (this._productGalleryInitialized) return;
    this._productGalleryInitialized = true;
    this.updateLoopingState();
    super.init();
    this.syncActiveMediaHeight();
    this.initMobileSnapGuard();
    this.initDesktopTrackpadScroll();
    // Warm offscreen media only after the page load event: started earlier, those
    // downloads compete with the first image and push out LCP on slow networks.
    // Touch and swipe handlers still prewarm on demand before that.
    this.preloadSlideMedia(this.itemsToShow[0], true).then(() => {
      const prewarm = () => requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.prewarmAdjacentMedia(0);
        this.prewarmGangCovers();
      }));
      if (document.readyState === 'complete') {
        prewarm();
      } else {
        window.addEventListener('load', prewarm, { once: true });
      }
    });

    const gallerySliderButtons = this.querySelector('.slider-buttons');
    if (gallerySliderButtons && this.querySelector('[data-gang-option]')) {
      if (this.querySelectorAll('.product__media-item.gang__active').length < 2) {
        gallerySliderButtons.classList.add('hidden');
      } else {
        gallerySliderButtons.classList.remove('hidden');
      }
    }

    this.updateVisibleDots();

    this.cursor = this.querySelector('.gallery-cursor');
    if (!this.cursor) return;

    this.addEventListener('mousemove', (event) => {
      if (event.target.closest('.product__modal-opener--image')) this.onMoveHandler(event);
    });
    this.addEventListener('mouseover', (event) => {
      if (event.target.closest('.product__modal-opener--image')) this.onEnterHandler();
    });
    this.addEventListener('mouseout', (event) => {
      if (!event.relatedTarget?.closest('.product__modal-opener--image')) this.onLeaveHandler();
    });
  }

  initPages() {
    this.refreshDesktopLoop();
    super.initPages();
  }

  resetPages() {
    this.removeDesktopLoop();
    super.resetPages();
  }

  removeDesktopLoop() {
    this.slider.querySelectorAll('.product-gallery-loop-copy').forEach((copy) => copy.remove());
    this.slider.classList.remove('product-gallery-loop');
    this._desktopLoop = null;
  }

  refreshDesktopLoop() {
    const slides = this.itemsToShow;
    const eligible = window.matchMedia(theme.config.mediaQueryProductDesktop).matches &&
      this.closest('.main-product-section .product--carousel') && !theme.config.rtl &&
      slides.length > 1 && slides.every((slide) =>
        slide.dataset.mediaType === 'image' ||
        (slide.dataset.mediaType === 'video' && slide.querySelector('.product__media video')));
    if (!eligible) {
      if (this._desktopLoop) {
        const selected = slides[(this.currentPage || 1) - 1] || slides[0];
        this.removeDesktopLoop();
        if (selected) this.scrollToSlide(selected, { behavior: 'auto' });
      }
      return;
    }

    const signature = [this.slider.clientWidth, ...slides.map((slide) => `${slide.id}:${slide.clientWidth}`)].join('|');
    if (this._desktopLoop?.signature === signature) return;
    const selected = slides[(this.currentPage || 1) - 1] || slides[0];
    this.removeDesktopLoop();
    this.slider.classList.add('product-gallery-loop');
    const cycleWidth = slides.reduce((width, slide) => width + slide.getBoundingClientRect().width, 0);
    if (!cycleWidth) return;
    const repetitions = Math.ceil(this.slider.clientWidth / cycleWidth);
    const makeCopies = () => {
      const fragment = document.createDocumentFragment();
      for (let repeat = 0; repeat < repetitions; repeat++) {
        slides.forEach((slide, index) => {
          const copy = document.createElement('li');
          copy.className = 'grid__item slider__slide product-gallery-loop-copy';
          copy.setAttribute('aria-hidden', 'true');
          const wrapper = document.createElement('div');
          wrapper.className = 'media-wrapper';
          const isVideo = slide.dataset.mediaType === 'video';
          const media = slide.querySelector(isVideo ? '.product__media:has(video)' : '.product__modal-opener--image .media').cloneNode(true);
          media.classList.remove('image-animate');
          media.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          const image = media.querySelector('img');
          if (image) {
            image.loading = 'eager';
            image.removeAttribute('is');
          }
          if (isVideo) {
            const video = media.querySelector('video');
            video.muted = true;
            video.autoplay = true;
            video.loop = true;
            video.tabIndex = -1;
            video.removeAttribute('controls');
            media.replaceChildren(video);
          }
          wrapper.appendChild(media);
          copy.appendChild(wrapper);
          copy.addEventListener('click', () => {
            if (this.isDragging) return;
            if (isVideo) {
              this.slider.scrollLeft = slide.offsetLeft;
              slide.querySelector('video')?.play().catch(() => {});
              return;
            }
            if (this.closest('.product--zoom-disabled')) return;
            this.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: true, detail: { index } }));
          });
          fragment.appendChild(copy);
        });
      }
      return fragment;
    };
    // Append copies so loop setup never moves the original media. Normalize
    // requested positions before the browser clamps negative scroll offsets.
    // Touch-first wide screens still need native backward-swipe runway.
    if (window.matchMedia('(pointer: coarse)').matches) this.slider.prepend(makeCopies());
    this.slider.append(makeCopies());
    this._desktopLoop = { signature, start: slides[0].offsetLeft, width: cycleWidth };
    this.slider.scrollLeft = selected.offsetLeft;
    if (this.isScrolling) this.scrollingPlay();
  }

  normalizeDesktopLoop(position = this.slider.scrollLeft) {
    const loop = this._desktopLoop;
    if (!loop || this.slider.classList.contains('product-gallery-variant-resetting')) return 0;
    const previous = position;
    if (previous === this.slider.scrollLeft && previous >= loop.start && previous < loop.start + loop.width) return 0;
    const next = loop.start + ((previous - loop.start) % loop.width + loop.width) % loop.width;
    this.slider.scrollLeft = next;
    return this.slider.scrollLeft - previous;
  }

  initDesktopTrackpadScroll() {
    if (!this.slider || this._desktopTrackpadScrollInitialized) return;
    this._desktopTrackpadScrollInitialized = true;

    this.slider.addEventListener('wheel', (event) => {
      if (window.matchMedia(theme.config.mediaQueryProductMobile).matches || theme.config.rtl) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

      const deltaMultiplier = event.deltaMode === WheelEvent.DOM_DELTA_LINE
        ? 16
        : event.deltaMode === WheelEvent.DOM_DELTA_PAGE
          ? this.slider.clientWidth
          : 1;
      const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
      if (this._desktopLoop) {
        event.preventDefault();
        this.scrollingPause();
        this.normalizeDesktopLoop(this.slider.scrollLeft + event.deltaX * deltaMultiplier);
        return;
      }
      const nextScrollLeft = Math.max(
        0,
        Math.min(maxScrollLeft, this.slider.scrollLeft + event.deltaX * deltaMultiplier)
      );

      if (nextScrollLeft === this.slider.scrollLeft) return;

      event.preventDefault();
      if (this._desktopLoop) this.scrollingPause();
      this.slider.scrollLeft = nextScrollLeft;
      this.normalizeDesktopLoop();
    }, { passive: false });
  }

  onMoveHandler(event) {
    this.cursor.style.left = `${event.clientX - 32}px`;
    this.cursor.style.top = `${event.clientY - 32}px`;
  }

  onEnterHandler() {
    this.cursor.classList.add('show');
  }

  onLeaveHandler() {
    this.cursor.classList.remove('show');
  }

  onButtonClick(event) {
    event.preventDefault();

    if (this._desktopLoop) {
      this.normalizeDesktopLoop(this.slider.scrollLeft +
        (event.currentTarget.name === 'next' ? 1 : -1) * this.sliderItemOffset);
      return;
    }

    this.updateLoopingState();
    const loopTarget = this.getLoopTarget(event.currentTarget.name);
    if (loopTarget) {
      this.scrollToSlide(loopTarget, { behavior: 'auto' });
      return;
    }

    super.onButtonClick(event);
  }

  getLoopTarget(direction) {
    if (!this.enableSliderLooping) return null;

    const visibleSlides = this.itemsToShow;

    if (!this.slider || visibleSlides.length < 2) return null;

    const firstSlide = visibleSlides[0];
    const lastSlide = visibleSlides[visibleSlides.length - 1];

    if (direction === 'next' && this.isSlideVisible(lastSlide, 1)) return firstSlide;
    if (direction === 'previous' && this.isSlideVisible(firstSlide, 1)) return lastSlide;

    return null;
  }

  scrollToSlide(slide, options = {}) {
    if (!slide || !this.slider) return;

    const isMobile = window.matchMedia(theme.config.mediaQueryProductMobile).matches;
    const originalScrollBehavior = this.slider.style.scrollBehavior;

    if (options.behavior === 'auto') {
      this.slider.style.scrollBehavior = 'auto';
    }

    if (isMobile && options.behavior === 'auto') {
      // A programmatic jump does not update Safari's snap target. Keep snap
      // off only while the height settles, then turn it back on. Leaving it
      // off until the next touch makes that swipe free-scroll.
      this.suspendSnapForLayout(() => {
        this.slider.scrollTo({ left: slide.offsetLeft });
        this.setActiveSlide(slide);
        this.syncActiveMediaHeight(slide);
      });
    } else if (isMobile) {
      // smooth scroll (dots): let it animate; the idle guard syncs the height
      // once the scroll settles on the target
      this.slider.scrollTo({ left: slide.offsetLeft });
      this.setActiveSlide(slide);
    } else {
      this.slider.scrollTo({ left: slide.offsetLeft });
      this.setActiveSlide(slide);
      this.syncActiveMediaHeight(slide);
    }

    if (options.behavior === 'auto') {
      this.slider.style.scrollBehavior = originalScrollBehavior;
    }
  }

  suspendSnapForLayout(fn) {
    const slider = this.slider;
    slider.style.scrollSnapType = 'none';
    fn();

    clearTimeout(this._snapRestoreTimer);
    const token = (this._snapRestoreToken || 0) + 1;
    this._snapRestoreToken = token;
    const restore = () => {
      if (this._snapRestoreToken !== token || !slider.isConnected) return;
      slider.style.scrollSnapType = '';
    };
    // The height transition is 240ms. Restoring snap while it runs makes
    // Safari retarget and stop between photos. Same-height slides can
    // restore on the next frame.
    const delay = slider.classList.contains('product-gallery-media-height-animating') ? 280 : 0;
    if (delay === 0) {
      requestAnimationFrame(() => requestAnimationFrame(restore));
    } else {
      this._snapRestoreTimer = setTimeout(restore, delay);
    }
  }

  onDotsClick(event) {
    event.preventDefault();

    const li = event.target.closest('li');
    if (!li || !this.dots || !this.dots.contains(li) || li.classList.contains('hidden')) return;

    const lis = Array.from(this.dots.querySelectorAll('li:not(.hidden)'));
    const index = lis.indexOf(li);
    const slide = this.itemsToShow[index];

    this.scrollToSlide(slide);
  }

  updateLoopingState() {
    this.enableSliderLooping = this.canLoopVisibleSlides();
  }

  canLoopVisibleSlides() {
    const visibleSlides = this.itemsToShow;

    if (!this.slider || visibleSlides.length < 2) return false;

    return !visibleSlides.some((slide) => this.isVideoSlide(slide));
  }

  isVideoSlide(slide) {
    return ['video', 'external_video'].includes(slide.dataset.mediaType) || !!slide.querySelector('video-section, video, iframe');
  }

  update() {
    this.updateLoopingState();

    if (this._desktopLoop) {
      this.normalizeDesktopLoop();
      const slides = this.itemsToShow;
      const previousPage = this.currentPage;
      const index = Math.round((this.slider.scrollLeft - this._desktopLoop.start) / this.sliderItemOffset);
      this.currentPage = index % slides.length + 1;
      const currentElement = slides[this.currentPage - 1];
      setTextIfChanged(this.currentPageElement, this.currentPage);
      setTextIfChanged(this.pageTotalElement, slides.length);
      if (this.prevButton) this.prevButton.removeAttribute('disabled');
      if (this.nextButton) this.nextButton.removeAttribute('disabled');
      if (previousPage !== this.currentPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: { currentPage: this.currentPage, currentElement } }));
      }
      this.syncGalleryVisualState(currentElement);
      return;
    }

    if (this.shouldDeferMobileScrollState()) {
      const nearest = this.prewarmNearestMediaFromScroll();
      // Caption contrast must follow the visible image during the gesture;
      // only the height/snap work needs to wait until scrolling settles.
      if (nearest?.dataset.mediaType === 'image' && this.closest('.main-product-section .product--carousel')) {
        this.setActiveSlide(nearest);
        this.syncActiveMediaAppearance(nearest);
      }
      return;
    }

    super.update();

    const currentElement = this.itemsToShow[this.currentPage - 1];

    // Mobile PDP locks height while scrolling, then animates to the selected
    // slide after snap. Updating height mid-gesture makes Safari re-resolve
    // the snap target and produces clipped/half-swiped media.
    const deferHeightSync = window.matchMedia(theme.config.mediaQueryProductMobile).matches &&
      this.shouldUseSmoothMobileMediaHeight();

    this.syncGalleryVisualState(currentElement, { syncHeight: !deferHeightSync });
  }

  shouldDeferMobileScrollState() {
    return window.matchMedia(theme.config.mediaQueryProductMobile).matches && this._mobileGestureActive;
  }

  syncGalleryVisualState(currentElement, options = {}) {
    const syncHeight = options.syncHeight !== false;

    if (currentElement) {
      this.setActiveSlide(currentElement);
      if (syncHeight) this.syncActiveMediaHeight(currentElement);
      else this.syncActiveMediaAppearance(currentElement);
    } else if (syncHeight) {
      this.syncActiveMediaHeight();
    }

    this.updateVisibleDots();
    this.updateCurrentDot();
  }

  // Runs on every scroll frame while the desktop gallery autoscrolls: class
  // writes must be no-ops when nothing changed, or each frame forces a
  // full-page style recalc on the next layout read.
  updateCurrentDot() {
    if (this.dots && (this.slidesPerPage == 0 || this.slidesPerPage == 1)) {
      const visibleDots = this.dots.querySelectorAll('li:not(.hidden)');
      const currentDot = visibleDots[this.currentPage - 1] || visibleDots[0];

      this.dots.querySelectorAll('li').forEach(item => {
        item.classList.toggle('current', item === currentDot);
      });
    }
  }

  setActiveSlide(slide) {
    if (!slide) return;

    Array.from(this.sliderItems).forEach((item) => {
      item.classList.toggle('is-active', item === slide);
    });
  }

  updateVisibleDots() {
    const gallerySliderDots = this.querySelector('.slider-dots');
    if (!gallerySliderDots) return;

    const dotList = gallerySliderDots.querySelector('ul');
    const dots = Array.from(gallerySliderDots.querySelectorAll('li'));
    if (!dots.length) return;

    if (!this.querySelector('[data-gang-option]')) {
      dots.forEach(item => item.classList.toggle('hidden', false));
      return;
    }

    const visibleDots = [];

    this.querySelectorAll('.product__media-item.gang__active').forEach((elm) => {
      const fallbackIndex = parseInt(elm.dataset.mediaPosition, 10) - 1;
      const dot = dots.find((item) => item.dataset.mediaId === elm.dataset.mediaId) || dots[fallbackIndex];

      if (dot && !visibleDots.includes(dot)) visibleDots.push(dot);
    });

    dots.forEach(item => item.classList.toggle('hidden', !visibleDots.includes(item)));

    if (!dotList || !visibleDots.length) return;

    // Visible dots must end the list in gallery order; skip the moves when
    // they already do.
    const tail = Array.from(dotList.children).slice(-visibleDots.length);
    if (visibleDots.every((dot, index) => tail[index] === dot)) return;

    visibleDots.forEach((dot) => {
      dotList.appendChild(dot);
    });
  }

  syncActiveMediaAppearance(slide) {
    const ratio = this.getSlideMediaRatio(slide);
    this.classList.toggle('product-gallery-active-portrait', Number.isFinite(ratio) && ratio > 100.5);
    this.syncPortraitDotContrast(slide);
  }

  syncActiveMediaHeight(slide) {
    if (!this.slider) return;

    const activeSlide = this.querySelector('.product__media-item.is-active.gang__active, .product__media-item.is-active');
    const currentSlide = slide || this.itemsToShow[this.currentPage - 1] || activeSlide || this.itemsToShow[0];
    const currentMedia = currentSlide && currentSlide.querySelector('.media');
    const currentRatio = currentMedia && currentMedia.style.getPropertyValue('--image-ratio-percent');
    this.syncActiveMediaAppearance(currentSlide);
    const useSmoothMobileHeight = this.shouldUseSmoothMobileMediaHeight();

    if (currentRatio) {
      this.slider.style.setProperty('--force-image-ratio-percent', currentRatio);
    }

    if (useSmoothMobileHeight) {
      this.syncSmoothMobileMediaHeight(currentSlide, currentMedia, currentRatio);
      return;
    }

    this.syncMobileMediaHeight(currentSlide, currentMedia, currentRatio);
  }

  // Portrait dots sit on the photo. Sample the strip behind them and use white
  // dots on a dark photo, black dots on a light one. The 0.4 scrim matches the
  // bottom of the portrait gradient, so the choice follows what is actually seen.
  syncPortraitDotContrast(slide) {
    const dots = this.dots;
    if (!dots || dots.querySelector('.slider-dots__item--thumbnail')) return;

    const portrait = this.classList.contains('product-gallery-active-portrait');
    if (!portrait) {
      this._dotContrastToken = (this._dotContrastToken || 0) + 1;
      dots.classList.remove('slider-dots--on-dark');
      return;
    }

    const img = slide && slide.querySelector('img');
    const src = img && (img.currentSrc || img.src);
    if (!src) {
      if (img && !img.complete) {
        img.addEventListener('load', () => {
          if (this.isConnected) this.syncPortraitDotContrast(slide);
        }, { once: true });
      }
      return;
    }

    if (!this._dotContrastCache) this._dotContrastCache = new Map();
    if (this._dotContrastCache.has(src)) {
      dots.classList.toggle('slider-dots--on-dark', this._dotContrastCache.get(src) === 'white');
      return;
    }

    const token = (this._dotContrastToken || 0) + 1;
    this._dotContrastToken = token;
    this.measurePortraitDotTone(src).then((tone) => {
      if (!this.isConnected || this._dotContrastToken !== token) return;
      if (tone) this._dotContrastCache.set(src, tone);
      const stillPortrait = this.classList.contains('product-gallery-active-portrait');
      dots.classList.toggle('slider-dots--on-dark', stillPortrait && tone === 'white');
    });
  }

  measurePortraitDotTone(src) {
    const scrim = 0.4;
    return new Promise((resolve) => {
      const probe = new Image();
      probe.decoding = 'async';
      probe.crossOrigin = 'anonymous';
      probe.onload = () => {
        try {
          const sampleWidth = 32;
          const sampleHeight = 8;
          const canvas = document.createElement('canvas');
          canvas.width = sampleWidth;
          canvas.height = sampleHeight;
          const context = canvas.getContext('2d', { willReadFrequently: true });
          if (!context || !probe.naturalWidth || !probe.naturalHeight) {
            resolve(null);
            return;
          }
          const cropHeight = Math.max(1, Math.round(probe.naturalHeight * 0.12));
          const cropWidth = Math.max(1, Math.round(probe.naturalWidth * 0.5));
          const cropX = Math.round((probe.naturalWidth - cropWidth) / 2);
          const cropY = probe.naturalHeight - cropHeight;
          context.drawImage(probe, cropX, cropY, cropWidth, cropHeight, 0, 0, sampleWidth, sampleHeight);
          const { data } = context.getImageData(0, 0, sampleWidth, sampleHeight);
          let luminance = 0;
          const pixels = data.length / 4;
          for (let i = 0; i < data.length; i += 4) {
            const alpha = data[i + 3] / 255;
            const channel = (value) => {
              // Transparent pixels show the page, which is white, not the photo.
              const flattened = (value * alpha + 255 * (1 - alpha)) / 255;
              const encoded = flattened * (1 - scrim);
              return encoded <= 0.04045 ? encoded / 12.92 : ((encoded + 0.055) / 1.055) ** 2.4;
            };
            luminance += 0.2126 * channel(data[i]) + 0.7152 * channel(data[i + 1]) + 0.0722 * channel(data[i + 2]);
          }
          // White and black text have equal contrast near 0.179 relative luminance.
          resolve(luminance / pixels < 0.179 ? 'white' : 'black');
        } catch (error) {
          // A tainted canvas cannot be sampled. Keep the default dark dots.
          if (error.name !== 'SecurityError') console.error(error);
          resolve(null);
        }
      };
      probe.onerror = () => resolve(null);
      probe.src = src;
    });
  }

  syncMobileMediaHeight(currentSlide, currentMedia, currentRatio) {
    if (this.shouldUseSmoothMobileMediaHeight()) {
      this.syncSmoothMobileMediaHeight(currentSlide, currentMedia, currentRatio);
      return;
    }

    const shouldSyncHeight = window.matchMedia(theme.config.mediaQueryProductMobile).matches &&
      (this.closest('.quick-view') || this.closest('.product__media-wrapper'));

    if (!shouldSyncHeight) {
      // toggle(…, false) leaves the attribute untouched when the class is
      // already absent; remove() rewrites it on every desktop scroll frame.
      this.slider.classList.toggle('quick-view-media-height-synced', false);
      this.slider.classList.toggle('product-gallery-media-height-synced', false);
      this.slider.style.removeProperty('--active-media-height');
      return;
    }

    const ratio = parseFloat(currentRatio);
    const width = this.slider.clientWidth || (currentSlide && currentSlide.clientWidth);
    const measuredHeight = currentMedia && currentMedia.getBoundingClientRect().height;
    const height = ratio && width ? Math.round((width * ratio) / 100) : Math.round(measuredHeight || 0);

    if (height > 0) {
      this.slider.style.setProperty('--active-media-height', `${height}px`);
      this.slider.classList.toggle('quick-view-media-height-synced', !!this.closest('.quick-view'));
      this.slider.classList.add('product-gallery-media-height-synced');
    } else {
      this.slider.classList.remove('quick-view-media-height-synced');
      this.slider.classList.remove('product-gallery-media-height-synced');
      this.slider.style.removeProperty('--active-media-height');
    }
  }

  shouldUseSmoothMobileMediaHeight() {
    return window.matchMedia(theme.config.mediaQueryProductMobile).matches &&
      this.closest('.product__media-wrapper') &&
      !this.closest('.quick-view') &&
      !this.closest('quick-view-drawer') &&
      this.slider;
  }

  getSlideMediaRatio(slide) {
    const media = slide && slide.querySelector('.media');
    const ratio = parseFloat(media && media.style.getPropertyValue('--image-ratio-percent'));
    return Number.isFinite(ratio) && ratio > 0 ? ratio : 0;
  }

  getMobileMediaHeight(currentSlide, currentMedia, currentRatio) {
    const ratio = parseFloat(currentRatio) || this.getSlideMediaRatio(currentSlide);
    const width = this.slider.clientWidth || (currentSlide && currentSlide.clientWidth);
    const measuredHeight = currentMedia && currentMedia.getBoundingClientRect().height;

    // Main carousel images use the shared portrait canvas, regardless of source ratio.
    if (currentSlide?.dataset.mediaType === 'image' &&
        this.closest('.main-product-section .product--carousel') &&
        currentMedia?.classList.contains('media-mobile--adapt') && measuredHeight > 0) {
      return Math.round(measuredHeight);
    }
    return ratio && width ? Math.round((width * ratio) / 100) : Math.round(measuredHeight || 0);
  }

  syncSmoothMobileMediaHeight(currentSlide, currentMedia, currentRatio) {
    const height = this.getMobileMediaHeight(currentSlide, currentMedia, currentRatio);
    if (height > 0) {
      const nextHeight = `${height}px`;
      const previousHeight = parseFloat(this.slider.style.getPropertyValue('--active-media-height'));
      const shouldAnimate = this._mobileMediaHeightReady &&
        this._animateNextMobileHeight &&
        Number.isFinite(previousHeight) &&
        Math.abs(previousHeight - height) > 1;

      if (this.slider.classList.contains('product-gallery-media-height-synced') &&
        this.slider.style.getPropertyValue('--active-media-height') === nextHeight) {
        this._mobileMediaHeightReady = true;
        this._animateNextMobileHeight = false;
        return;
      }

      if (shouldAnimate) {
        this.slider.classList.add('product-gallery-media-height-animating');
      } else {
        this.slider.classList.remove('product-gallery-media-height-animating');
      }

      this.slider.style.setProperty('--active-media-height', nextHeight);
      this.slider.classList.remove('quick-view-media-height-synced');
      this.slider.classList.add('product-gallery-media-height-synced');
      this._mobileMediaHeightReady = true;
      this._animateNextMobileHeight = false;

      clearTimeout(this._mobileMediaHeightAnimationTimer);
      if (shouldAnimate) {
        this._mobileMediaHeightAnimationTimer = setTimeout(() => {
          this.slider.classList.remove('product-gallery-media-height-animating');
        }, 280);
      }
    } else {
      this._mobileMediaHeightReady = false;
      this._animateNextMobileHeight = false;
      this.slider.classList.remove('product-gallery-media-height-synced');
      this.slider.classList.remove('product-gallery-media-height-animating');
      this.slider.style.removeProperty('--active-media-height');
    }
  }

  goToFirstSlide(options = {}) {
    this.scrollToSlide(this.itemsToShow[0] || this.sliderItems[0], options);
  }

  resetAfterVariantChange(mediaId = '') {
    if (!this.slider) return;

    this._variantResetId = (this._variantResetId || 0) + 1;
    const resetId = this._variantResetId;

    clearTimeout(this._mobileSnapIdleTimer);
    clearTimeout(this._mobileMediaHeightAnimationTimer);
    this._touching = false;
    this._mobileGestureActive = false;
    this._predictedTouchIndex = 0;
    this._animateNextMobileHeight = false;
    this.slider.classList.remove('product-gallery-media-height-animating');
    if (!this.slider.classList.contains('product-gallery-variant-resetting')) {
      this._variantResetScrollBehavior = this.slider.style.scrollBehavior;
    }
    this.slider.classList.add('product-gallery-variant-resetting');

    // Changing overflow cancels Safari's in-flight momentum before the
    // incoming colour changes the visible slide set and its dimensions.
    const stopAtFirstSlide = () => {
      this.slider.style.scrollBehavior = 'auto';
      this.slider.scrollLeft = 0;
    };
    if (window.matchMedia(theme.config.mediaQueryProductMobile).matches) {
      this.suspendSnapForLayout(stopAtFirstSlide);
    } else {
      stopAtFirstSlide();
    }

    requestAnimationFrame(() => {
      if (this._variantResetId !== resetId) return;

      // gang visibility and featured-media prepends are now reflected in
      // layout; rebuild the list before choosing the new first visible slide.
      this.resetPages();
      const requestedSlide = mediaId
        ? this.slider.querySelector(`[data-media-id="${mediaId}"]`)
        : null;
      const firstSlide = requestedSlide && requestedSlide.clientWidth > 0
        ? requestedSlide
        : this.itemsToShow[0];

      if (firstSlide) {
        this.slider.scrollLeft = firstSlide.offsetLeft;
        this.setActiveSlide(firstSlide);
        this.currentPage = Math.max(1, this.itemsToShow.indexOf(firstSlide) + 1);
        this.syncGalleryVisualState(firstSlide, { syncHeight: true });
        this.prewarmAdjacentMedia(this.currentPage - 1);
      }

      requestAnimationFrame(() => {
        if (this._variantResetId !== resetId) return;
        this.slider.classList.remove('product-gallery-variant-resetting');
        this.slider.style.scrollBehavior = this._variantResetScrollBehavior || '';
        delete this._variantResetScrollBehavior;
      });
    });
  }

  getSlideMediaImage(slide) {
    if (!slide) return null;
    const selector = '.product__modal-opener--image img, .media img, img';
    return slide.querySelector(selector)
      || slide.querySelector('template[data-product-media]')?.content.querySelector(selector);
  }

  preloadSlideMedia(slide, highPriority = false) {
    const image = this.getSlideMediaImage(slide);
    if (!image) return Promise.resolve();

    const src = image.currentSrc || image.getAttribute('src') || '';
    const srcset = image.getAttribute('srcset') || '';
    if (!src && !srcset) return Promise.resolve();

    image.loading = 'eager';
    image.fetchPriority = highPriority ? 'high' : 'low';

    return new Promise((resolve) => {
      if (image.complete && image.naturalWidth > 0) {
        if (image.decode) image.decode().catch(() => {}).finally(resolve);
        else resolve();
        return;
      }

      const preload = new Image();
      const finish = () => {
        if (preload.decode) preload.decode().catch(() => {}).finally(resolve);
        else resolve();
      };

      preload.onload = finish;
      preload.onerror = resolve;
      preload.fetchPriority = highPriority ? 'high' : 'low';
      preload.sizes = image.getAttribute('sizes') || image.sizes || '';
      if (srcset) preload.srcset = srcset;
      preload.src = src;
    });
  }

  prewarmAdjacentMedia(index = this.currentPage - 1) {
    const slides = this.itemsToShow;
    if (!slides.length) return;

    [index - 1, index, index + 1, index + 2].forEach((slideIndex) => {
      const slide = slides[slideIndex];
      if (!slide) return;
      this.preloadSlideMedia(slide, slideIndex === index || slideIndex === index + 1);
    });
  }

  prewarmNearestMediaFromScroll() {
    const slides = this.itemsToShow;
    if (!this.slider || slides.length < 2) return;

    const scrollLeft = this.slider.scrollLeft;
    let nearestIndex = 0;
    slides.forEach((slide, index) => {
      const nearest = slides[nearestIndex];
      if (Math.abs(slide.offsetLeft - scrollLeft) < Math.abs(nearest.offsetLeft - scrollLeft)) {
        nearestIndex = index;
      }
    });

    this.prewarmAdjacentMedia(nearestIndex);
    return slides[nearestIndex];
  }

  predictMobileSwipeTarget(clientX, clientY) {
    if (!this._touching || !this.slider || !window.matchMedia(theme.config.mediaQueryProductMobile).matches) return;

    const deltaX = clientX - this._touchStartX;
    const deltaY = clientY - this._touchStartY;
    if (Math.abs(deltaX) < 12) return;

    if (Math.abs(deltaX) < Math.abs(deltaY) * 1.25) {
      this._predictedTouchIndex = this._touchStartIndex;
      return;
    }

    const slides = this.itemsToShow;
    if (slides.length < 2) return;

    const direction = deltaX < 0 ? 1 : -1;
    const targetIndex = Math.max(0, Math.min(slides.length - 1, this._touchStartIndex + direction));
    if (targetIndex === this._predictedTouchIndex) return;

    this._predictedTouchIndex = targetIndex;
    this.prewarmAdjacentMedia(targetIndex);
  }

  // Non-active colour (gang) media are display:none with loading=lazy, so
  // they never fetch until the variant is switched — the gallery then resizes
  // to the new ratio with an empty frame and the image pops in a beat later
  // (the "two-step" transition). Warm each colour's first image during idle
  // time; eager images fetch even inside display:none subtrees.
  prewarmGangCovers() {
    if (this._gangCoversPrewarmed) return;
    this._gangCoversPrewarmed = true;

    const idle = window.requestIdleCallback
      ? (fn) => window.requestIdleCallback(fn, { timeout: 600 })
      : (fn) => setTimeout(fn, 400);
    idle(async () => {
      const seen = new Set();
      for (const media of this.querySelectorAll('.product__media-item[data-gang-connect]')) {
        if (!this.isConnected) return;
        const gang = media.dataset.gangConnect;
        if (seen.has(gang)) continue;
        seen.add(gang);

        const image = this.getSlideMediaImage(media);
        if (image && image.loading === 'lazy') await this.preloadSlideMedia(media);
      }
    });
  }

  // safety net for mobile momentum swipes: once the gesture settles, if the
  // scroll position is not aligned on a visible slide (overswipe, snap miss),
  // snap instantly to the nearest one and sync the height from it
  initMobileSnapGuard() {
    if (!this.slider || this._snapGuardInitialized) return;
    this._snapGuardInitialized = true;

    this.slider.addEventListener('touchstart', (event) => {
      const touch = event.touches && event.touches[0];
      this._touching = true;
      this._mobileGestureActive = true;
      this._touchStartX = touch ? touch.clientX : 0;
      this._touchStartY = touch ? touch.clientY : 0;
      this._touchStartIndex = Math.max(0, (this.currentPage || 1) - 1);
      this._predictedTouchIndex = this._touchStartIndex;
      this.prewarmAdjacentMedia(this._touchStartIndex);
    }, { passive: true });
    this.slider.addEventListener('touchmove', (event) => {
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      this.predictMobileSwipeTarget(touch.clientX, touch.clientY);
    }, { passive: true });
    this.slider.addEventListener('touchend', () => {
      this._touching = false;
      this.queueMobileSnapCorrection(90);
    }, { passive: true });
    this.slider.addEventListener('touchcancel', () => {
      this._touching = false;
      this._mobileGestureActive = false;
      this.queueMobileSnapCorrection(0);
    }, { passive: true });

    this.slider.addEventListener('scroll', () => {
      this.queueMobileSnapCorrection(90);
    }, { passive: true });
  }

  queueMobileSnapCorrection(delay = 90) {
    if (this.slider.classList.contains('product-gallery-variant-resetting')) return;

    clearTimeout(this._mobileSnapIdleTimer);
    this._mobileSnapIdleTimer = setTimeout(() => this.correctSnapPosition(), delay);
  }

  correctSnapPosition() {
    if (this.slider.classList.contains('product-gallery-variant-resetting')) return;
    if (this._touching) return;
    if (!window.matchMedia(theme.config.mediaQueryProductMobile).matches) {
      this._mobileGestureActive = false;
      return;
    }

    const slides = this.itemsToShow;
    if (slides.length < 2) {
      this._mobileGestureActive = false;
      return;
    }

    const scrollLeft = this.slider.scrollLeft;
    let nearest = slides[0];
    slides.forEach((slide) => {
      if (Math.abs(slide.offsetLeft - scrollLeft) < Math.abs(nearest.offsetLeft - scrollLeft)) {
        nearest = slide;
      }
    });

    this._mobileGestureActive = false;
    const misaligned = Math.abs(nearest.offsetLeft - scrollLeft) > 1;
    const nextHeight = this.getMobileMediaHeight(nearest, nearest.querySelector('.media'));
    const previousHeight = parseFloat(this.slider.style.getPropertyValue('--active-media-height'));
    const heightChanges = Number.isFinite(previousHeight) && nextHeight > 0 && Math.abs(previousHeight - nextHeight) > 1;
    const settle = () => {
      super.update();
      this._animateNextMobileHeight = true;
      this.syncGalleryVisualState(nearest, { syncHeight: true });
      this.prewarmAdjacentMedia(slides.indexOf(nearest));
    };

    // A swipe that already landed must not turn snap off. Doing that left
    // the next gesture as a free scroll whenever Safari read the style
    // before the touchstart listener could put snap back.
    if (!misaligned && !heightChanges) {
      settle();
      return;
    }

    this.suspendSnapForLayout(() => {
      if (misaligned) {
        const originalScrollBehavior = this.slider.style.scrollBehavior;
        this.slider.style.scrollBehavior = 'auto';
        this.slider.scrollTo({ left: nearest.offsetLeft });
        this.slider.style.scrollBehavior = originalScrollBehavior;
      }
      settle();
    });
  }
}
customElements.define('product-gallery', ProductGallery);

class ProductMeasurementPhoto extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('img');
    this.variantImages = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.onVariantChange = (event) => {
      const source = this.variantImages[event.detail?.variant?.id];
      if (!source || !this.image) return;
      this.image.removeAttribute('srcset');
      this.image.src = source.src;
      this.dataset.view = source.view;
    };
    document.addEventListener('variant:change', this.onVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:change', this.onVariantChange);
  }
}
customElements.define('product-measurement-photo', ProductMeasurementPhoto);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onVariantChange);

    this.updateOptions();
    this.updateMasterId();
    this.setAvailability();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    const disableAddButton = !this.currentVariant || !this.currentVariant.available;

    this.toggleAddButton(
      disableAddButton,
      this.currentVariant && !this.currentVariant.available ? theme.variantStrings.soldOut : '',
      false
    );
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.validateGang();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.setAvailabilityInUnavailable();
    } else {
      this.scheduleMediaUpdate();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.setAvailability();

      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          variant: this.currentVariant
        }
      }));
    }

    this.handleStickyCart(event.target);
  }

  // The gallery swap forces several full-page layouts (over half a second on
  // mid-range phones). Running it after the next paint lets the tapped swatch,
  // colour label and buy button update first; INP ends at that paint.
  scheduleMediaUpdate() {
    cancelAnimationFrame(this.mediaUpdateFrame);
    clearTimeout(this.mediaUpdateTimer);
    this.mediaUpdateFrame = requestAnimationFrame(() => {
      this.mediaUpdateTimer = setTimeout(() => {
        if (!this.isConnected || !this.currentVariant) return;
        if (this.gangOption) {
          this.updateGangMedia();
        } else {
          this.updateMedia();
        }
      });
    });
  }

  handleStickyCart(target) {
    const stickyCart = document.getElementById(`sticky-cart-${this.dataset.section}`);
    if (!stickyCart) return;

    const attribute = target.getAttribute('name');

    document.querySelectorAll(`variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`)
    .forEach((input) => {
      if (input.tagName === 'INPUT') {
        input.checked = input.value === target.value;
      }
      else {
        input.value = target.value;
      }
    });

    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const image = document.querySelector('.sticky-cart__content-image img');
    if (image) {
      image.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`;
      image.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`;
      image.width = 70;
      image.height = Math.ceil(70 / this.currentVariant.featured_media.preview_image.aspect_ratio);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData()?.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  
  validateGang() {
    const mediaItemWithGang = document.querySelector(`#shopify-section-${this.dataset.section} [data-gang-option], quick-view-drawer details[open] [data-gang-option]`);
    if (mediaItemWithGang) {
      this.gangOption = mediaItemWithGang.dataset.gangOption;
    }
  }
  
  updateGangMedia() {
    if (!this.gangOption) return;

    const variantInputWrapper = this.querySelector('.variant-input-wrapper[data-option-slug="'+this.gangOption+'"]');
    if (variantInputWrapper) {
      this.gangIndex = variantInputWrapper.dataset.optionIndex;
    } else {
      this.gangOption = null;
    }

    if (!this.currentVariant) return;
    //if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const gangValue = this.getSlug(this.currentVariant[this.gangIndex], true);
    if (this.currentGangValue !== gangValue) {
      document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect], quick-view-drawer details[open] [data-gang-connect]`
      ).forEach(function(media){
        media.classList.remove('gang__active');
      });

      this.currentGangValue = gangValue;
      var gangConnect = this.gangOption + '_' + gangValue;
      var gangConnectAll = this.gangOption + '_all';
      const newMedias = document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect="${gangConnect}"], quick-view-drawer details[open] [data-gang-connect="${gangConnect}"], #shopify-section-${this.dataset.section} [data-gang-connect="${gangConnectAll}"], quick-view-drawer details[open] [data-gang-connect="${gangConnectAll}"]`
      );

      if (!newMedias.length) return;

      newMedias.forEach((media) => {
        const template = media.querySelector('template[data-product-media]');
        if (template) template.replaceWith(template.content);
      });

      // the incoming colour's leading images are about to be shown — fetch
      // them now at high priority so the ratio change and the pixels land
      // together instead of the "two-step" resize-then-pop
      Array.from(newMedias).slice(0, 3).forEach(function(newMedia, index) {
        const img = newMedia.querySelector('img');
        if (!img) return;
        if (img.loading === 'lazy') img.loading = 'eager';
        if (index === 0) img.setAttribute('fetchpriority', 'high');
      });

      Array.from(newMedias).reverse().forEach(function(newMedia) {
        newMedia.classList.add('gang__active');
        let parent = newMedia.parentElement;
        if (parent.firstChild != newMedia) {
          // parent.prepend(newMedia);
          parent.classList.add('product__media-no-animate');
        }
      });

      const thumbnailSlider = document.getElementById(`GalleryThumbnails-${this.dataset.section}`);
      if (thumbnailSlider) {
        const inactiveItems = thumbnailSlider.querySelectorAll('.thumbnail-list__item:not(.gang__active)');
        thumbnailSlider.slider.dataset.mediaCount = thumbnailSlider.sliderItems.length - inactiveItems.length;
        if (thumbnailSlider.slider.dataset.mediaCount < 2) {
          thumbnailSlider.classList.add('hidden');
        } else {
          thumbnailSlider.classList.remove('hidden');
        }
        thumbnailSlider.resetPages();
      }

      const gallerySliderButtons = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .slider-buttons, quick-view-drawer details[open] product-gallery .slider-buttons`);
      if (gallerySliderButtons) {
        if (document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).length < 2) {
          gallerySliderButtons.classList.add('hidden');
        } else {
          gallerySliderButtons.classList.remove('hidden');
        }
      }
    }

    if (!this.currentVariant.featured_media) {
      if(!document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active.is-active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active.is-active`).length) {
        document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).classList.add('is-active');
      }
      const productGallery = mediaGallery
        ? mediaGallery.querySelector('product-gallery')
        : document.querySelector(`#shopify-section-${this.dataset.section} product-gallery, quick-view-drawer details[open] product-gallery`);
      if (productGallery) productGallery.resetAfterVariantChange();
      return;
    }

    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView);

      // reconcile after the prepend reordered the slides: rewind to the (new)
      // first slide and sync the gallery height from the media actually shown
      const activeProductGallery = mediaGallery.querySelector('product-gallery');
      if (activeProductGallery) {
        activeProductGallery.resetAfterVariantChange(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
      }
    }
    
    const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      thumbnailContent.prepend(newMediaThumbnail);
    }
  }

  CJKDetect(someString) {
    // Korean
    if (someString.search("[\uac00-\ud7a3]") >= 0) return "ko";
    // Japanese
    if (someString.search("[\u3040-\u30ff]") >= 0) return "ja";
    // Chinese
    if (someString.search("[\u4e00-\u9FFF]") >= 0) return "zh";
  
    return "none";
  }

  getSlug(someString, removeAccent = false) {
    if (this.CJKDetect(someString) != "none") return someString;
    if(removeAccent) {
      return someString.toLowerCase().replace(/[à-ú]+/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    } else {
      return someString.toString().replace('ı', 'i').normalize('NFD').replace('-', ' ').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, "-");
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    
    const parent = newMedia.parentElement;
    if (parent.firstElementChild !== newMedia) {
      parent.prepend(newMedia);
      parent.classList.add('product__media-no-animate');
    }

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView);
      const productGallery = mediaGallery.querySelector('product-gallery');
      if (productGallery) {
        productGallery.resetAfterVariantChange(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
      }
    } else if (parent.parentElement && typeof parent.parentElement.resetAfterVariantChange === 'function') {
      parent.parentElement.resetAfterVariantChange(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }
    
    const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      thumbnailContent.prepend(newMediaThumbnail);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}--alt, #product-form-${this.dataset.section}--mobile-sticky`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        this.updateSKU(responseText);
        this.updatePrice(responseText);
        this.updatePriceAlt(responseText);
        this.updateColorName(responseText);
        this.updateSoclozBtn(responseText);
        this.updateInventoryStatus(responseText);
        this.updateShippingDate(responseText);
        if (this.currentVariant) this.toggleAddButton(!this.currentVariant.available, theme.variantStrings.soldOut);
        this.updateCustomLiquid(responseText);

        document.dispatchEvent(new CustomEvent('productInfo:loaded'));

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            variant: this.currentVariant,
          },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateSoclozBtn(responseText) {
    const id = `button-socloz-product-form-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) {
      destination.dataset.soclozProductId = source.dataset.soclozProductId;
      if(source.dataset.soclozProductAttributesColor) destination.dataset.soclozProductAttributesColor = source.dataset.soclozProductAttributesColor;
      if(source.dataset.soclozProductAttributesClothes_size) destination.dataset.soclozProductAttributesClothes_size = source.dataset.soclozProductAttributesClothes_size;
    }
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updateSKU(responseText) {
    const id = `sku-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updateCustomLiquid(responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destinations = document.querySelectorAll(`.custom__liquid-${this.dataset.section}`);
    const sources = html.querySelectorAll(`.custom__liquid-${this.dataset.section}`);

    for (let i = 0, clLength = destinations.length ; i < clLength ; i++) {
      const destination = destinations[i];
      const source = sources[i];

      if (!source || this.shouldPreserveCustomLiquid(destination, source)) continue;

      destination.innerHTML = source.innerHTML;
      Array.from(destination.querySelectorAll("script"))
      .forEach( oldScriptEl => {
        const newScriptEl = document.createElement("script");
        
        Array.from(oldScriptEl.attributes).forEach( attr => {
          newScriptEl.setAttribute(attr.name, attr.value) 
        });
        
        const scriptText = document.createTextNode(oldScriptEl.innerHTML);
        newScriptEl.appendChild(scriptText);
        
        oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
      });
    }
  }

  shouldPreserveCustomLiquid(destination, source) {
    return destination.querySelector('.skeepers_product__stars') && source.querySelector('.skeepers_product__stars');
  }

  updatePrice(responseText) {
    const id = `price-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updatePriceAlt(responseText) {
    const id = `price-${this.dataset.section}--alt`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updateColorName(responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    
    for (let index = 1; index <= 3; index++) {
      const id = index > 1 ? `color-${this.dataset.section}-${index}` : `color-${this.dataset.section}`;
      const destination = document.getElementById(id);
      const source = html.getElementById(id);

      if (source && destination) destination.innerHTML = source.innerHTML;
      if (destination) destination.classList.remove('visibility-hidden');
    }
  }

  updateInventoryStatus(responseText) {
    const id = `inventory-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove('visibility-hidden');
  }

  updateShippingDate(responseText) {
    const id = `shipping-date-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.setAttribute('class', source.getAttribute('class') || '');

      ['data-estimate-mode', 'data-business-days'].forEach((attributeName) => {
        if (source.hasAttribute(attributeName)) {
          destination.setAttribute(attributeName, source.getAttribute(attributeName));
        } else {
          destination.removeAttribute(attributeName);
        }
      });

      if (typeof destination.update === 'function') destination.update();
    }
    if (destination) destination.classList.remove('visibility-hidden');
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt, #product-form-${this.dataset.section}--mobile-sticky`);
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      if (this.shouldUseBackInStockProxy(productForm, disable, text)) {
        this.setBackInStockProxyButton(addButton);
        return;
      }

      this.resetBackInStockProxyButton(addButton);

      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButton.textContent = text;
      }
      else {
        addButton.removeAttribute('disabled');
        const buttonText = addButton.dataset.preOrder === 'true' ? theme.variantStrings.preOrder : theme.variantStrings.addToCart;
        addButton.innerHTML = this.getAddButtonHTML(buttonText);
      }

      if (!modifyClass) return;
    });
  }

  shouldUseBackInStockProxy(productForm, disable, text) {
    return disable
      && text === theme.variantStrings.soldOut
      && !!productForm.closest('.main-product-section, .featured-product, quick-view-drawer, mobile-sticky-add-to-cart');
  }

  setBackInStockProxyButton(addButton) {
    addButton.type = 'button';
    addButton.removeAttribute('disabled');
    addButton.removeAttribute('aria-disabled');
    addButton.classList.remove('loading');
    addButton.dataset.backInStockProxy = 'true';
    addButton.innerHTML = this.getAddButtonHTML(this.getBackInStockButtonText());
  }

  resetBackInStockProxyButton(addButton) {
    if (!addButton.dataset.backInStockProxy) return;

    addButton.type = 'submit';
    delete addButton.dataset.backInStockProxy;
  }

  getBackInStockButtonText() {
    const appTrigger = document.getElementById('BIS_trigger');
    const appTriggerText = appTrigger && appTrigger.textContent.trim();

    return appTriggerText || "M'alerter de la disponibilit\u00e9";
  }

  getAddButtonHTML(text) {
    const pricing = this.getCurrentVariantPricing();

    if (!pricing) return this.escapeHTML(text);

    const buttonText = `<span class="product-form__submit-label">${this.escapeHTML(text)}</span>`;

    if (pricing.compareAtPrice) {
      return `${buttonText}<span class="product-form__submit-separator" aria-hidden="true">\u2014</span><s class="product-form__submit-price-compare">${this.escapeHTML(pricing.compareAtPrice)}</s><span class="product-form__submit-price product-form__submit-price--sale"><span class="product-form__submit-price-current">${this.escapeHTML(pricing.price)}</span></span>`;
    }

    return `${buttonText}<span class="product-form__submit-separator" aria-hidden="true">\u2014</span><span class="product-form__submit-price">${this.escapeHTML(pricing.price)}</span>`;
  }

  getCurrentVariantPricing() {
    if (!this.currentVariant || this.currentVariant.price == null) return '';

    const price = this.formatAddButtonPrice(this.currentVariant.price);
    const compareAtPrice = this.currentVariant.compare_at_price > this.currentVariant.price
      ? this.formatAddButtonPrice(this.currentVariant.compare_at_price)
      : '';

    return { price, compareAtPrice };
  }

  formatAddButtonPrice(cents) {
    return theme.Currency.formatMoneyWithoutTrailingZeros(cents, theme.shopSettings.moneyFormat)
      .replace(/<[^>]*>/g, '')
      .trim();
  }

  escapeHTML(value) {
    const htmlEscapes = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };

    return String(value).replace(/[&<>"']/g, (character) => htmlEscapes[character]);
  }

  setUnavailable() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt, #product-form-${this.dataset.section}--mobile-sticky`);
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;
      this.resetBackInStockProxyButton(addButton);
      addButton.textContent = theme.variantStrings.unavailable;

      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.add('visibility-hidden');

      const priceAlt = document.getElementById(`price-${this.dataset.section}--alt`);
      if (priceAlt) priceAlt.classList.add('visibility-hidden');

      const inventory = document.getElementById(`inventory-${this.dataset.section}`);
      if (inventory) inventory.classList.add('visibility-hidden');

      const shippingDate = document.getElementById(`shipping-date-${this.dataset.section}`);
      if (shippingDate) shippingDate.classList.add('visibility-hidden');
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  setAvailability() {
    if (!this.currentVariant) return;

    this.querySelectorAll('.variant-input-wrapper').forEach(group => {
      this.disableVariantGroup(group);
    });

    const currentlySelectedValues = this.currentVariant.options.map((value,index) => {return {value, index: `option${index+1}`}})
    const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }

  setAvailabilityInUnavailable() {
    this.querySelectorAll('.variant-input-wrapper').forEach(group => {
      this.disableVariantGroup(group);
    });

    const currentlySelectedValues = this.options.map((value,index) => {return {value, index: `option${index+1}`}})
    const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }

  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
    group.querySelector('option[value="'+ value +'"]').disabled = false;
  }

  disableVariantGroup(group) {
    group.querySelectorAll('option').forEach((option) => {
      option.disabled = true;
    });
  }

  manageOptionState(option, values) {
    const group = this.querySelector('.variant-input-wrapper[data-option-index="'+ option +'"]');

    // Loop through each option value
    values.forEach(obj => {
      this.enableVariantOption(group, obj);
    });
  }

  createAvailableOptionsTree(variants, currentlySelectedValues) {
    // Reduce variant array into option availability tree
    return variants.reduce((options, variant) => {

      // Check each option group (e.g. option1, option2, option3) of the variant
      Object.keys(options).forEach(index => {

        if (variant[index] === null) return;

        let entry = options[index].find(option => option.value === variant[index]);

        if (typeof entry === 'undefined') {
          // If option has yet to be added to the options tree, add it
          entry = {value: variant[index], soldOut: true}
          options[index].push(entry);
        }

        const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
        const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')

        switch (index) {
          case 'option1':
            // Option1 inputs should always remain enabled based on all available variants
            entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            break;
          case 'option2':
            // Option2 inputs should remain enabled based on available variants that match first option group
            if (currentOption1 && variant['option1'] === currentOption1.value) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
          case 'option3':
            // Option 3 inputs should remain enabled based on available variants that match first and second option group
            if (
              currentOption1 && variant['option1'] === currentOption1.value
              && currentOption2 && variant['option2'] === currentOption2.value
            ) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
        }
      })

      return options;
    }, { option1: [], option2: [], option3: []})
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    const showMoreSwatchesBtn = this.querySelector('li.more-swatch button');
    this.swatchesWrapper = this.querySelector('.product-form__input-wrapper');
    this.swatchesVisible = false;
    this.swatchScrollWrappers = Array.from(this.querySelectorAll('.product-form__input-wrapper')).filter((wrapper) => {
      return wrapper.querySelector('.color__swatch--variant');
    });
    this.updateSwatchScrollHints = this.updateSwatchScrollHints.bind(this);

    if (showMoreSwatchesBtn) {
      showMoreSwatchesBtn.addEventListener('click', this.toggleSwatchesVisibility.bind(this));
    }
    this.swatchScrollWrappers.forEach((wrapper) => {
      wrapper.addEventListener('scroll', this.updateSwatchScrollHints, { passive: true });
    });
    window.addEventListener('resize', this.updateSwatchScrollHints);
    this.initialSwatchFrame = requestAnimationFrame(() => {
      this.initialSwatchFrame = null;
      this.focusInitialSelectedSwatches();
      this.updateSwatchScrollHints();
    });
  }

  focusInitialSelectedSwatches() {
    this.swatchScrollWrappers.forEach((wrapper) => {
      const input = wrapper.querySelector('input[type="radio"]:checked');
      const item = input && input.closest('li');
      if (!item || wrapper.clientWidth <= 0) return;

      const centeredLeft = item.offsetLeft - (wrapper.clientWidth - item.offsetWidth) / 2;
      const maxLeft = Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);
      wrapper.scrollLeft = Math.min(maxLeft, Math.max(0, centeredLeft));
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
    const input = group.querySelector('input[data-option-value="'+ value +'"]');

    if(!input) return;

    // Variant exists - enable & show variant
    input.removeAttribute('disabled');
    input.removeAttribute('data-crossout');

    // Variant sold out - cross out option (remains selectable)
    if (obj.soldOut) {
      if (this.hasAttribute('data-swatch-cross')) {
        if (this.hasAttribute('data-swatch-oos-click')) {
          input.setAttribute('data-crossout', '');
        } else {
          input.setAttribute('disabled', '');
        }
      }
    }
  }

  disableVariantGroup(group) {
    group.querySelectorAll('input').forEach((input) => {
      input.setAttribute('disabled', '');
    });
  }

  toggleSwatchesVisibility(event) {
    
    let swatchesElement = this.swatchesWrapper.querySelectorAll('li.hidden,li.is-visible');
    if(!this.swatchesVisible) {
      swatchesElement.forEach((swatch) => {
        swatch.classList.remove('hidden');
        swatch.classList.add('is-visible');
      });
      this.swatchesWrapper.classList.add('swatches-visible');
      this.swatchesVisible = true;
    } else {
      swatchesElement.forEach((swatch) => {
        swatch.classList.add('hidden');
        swatch.classList.remove('is-visible');
      });
      this.swatchesWrapper.classList.remove('swatches-visible');
      
      this.swatchesVisible = false;
    }
    event.currentTarget.querySelectorAll('small').forEach((small) => {
      small.classList.toggle('hidden');
    })
    this.updateSwatchScrollHints();
  }

  updateSwatchScrollHints() {
    if (!this.swatchScrollWrappers) return;

    this.swatchScrollWrappers.forEach((wrapper) => {
      const fieldset = wrapper.closest('.product-form__input');
      if (!fieldset) return;

      const isScrollable = wrapper.scrollWidth > wrapper.clientWidth + 1;
      const isAtStart = wrapper.scrollLeft <= 1;
      const isAtEnd = Math.ceil(wrapper.scrollLeft + wrapper.clientWidth) >= wrapper.scrollWidth - 1;

      fieldset.classList.toggle('swatch-scrollable', isScrollable);
      fieldset.classList.toggle('swatch-scroll-at-start', !isScrollable || isAtStart);
      fieldset.classList.toggle('swatch-scroll-at-end', !isScrollable || isAtEnd);
    });
  }

  disconnectedCallback() {
    if (this.initialSwatchFrame) cancelAnimationFrame(this.initialSwatchFrame);
    if (this.swatchScrollWrappers) {
      this.swatchScrollWrappers.forEach((wrapper) => {
        wrapper.removeEventListener('scroll', this.updateSwatchScrollHints);
      });
    }
    window.removeEventListener('resize', this.updateSwatchScrollHints);
  }
}
customElements.define('variant-radios', VariantRadios);

class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.miniCart = document.querySelector('mini-cart');
    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('click', this.onBackInStockProxyClick.bind(this));
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  onBackInStockProxyClick(evt) {
    const proxyButton = evt.target.closest('[data-back-in-stock-proxy="true"]');
    if (!proxyButton || !this.contains(proxyButton)) return;

    evt.preventDefault();
    // Store Connect (app embed) owns back-in-stock alerts; AMP stays as the
    // fallback until its embed is switched off on the live store.
    if (window.StoreConnect && typeof window.StoreConnect.openAlert === 'function') {
      const variantInput = this.form.querySelector('[name="id"]');
      window.StoreConnect.openAlert(variantInput ? variantInput.value : undefined);
      return;
    }
    const appTrigger = document.getElementById('BIS_trigger');
    if (appTrigger && appTrigger !== proxyButton) {
      appTrigger.click();
      this.styleBackInStockPopup();
    } else if (!appTrigger && window.BIS && window.BIS.popup) {
      // The app may not attach its trigger when the page starts on a sold-out variant.
      const popup = window.BIS.popup;
      const variantId = this.form.querySelector('[name="id"]').value;
      popup.ready.then(() => {
        popup.show({ variantId });
        this.styleBackInStockPopup();
      });
    }
  }

  styleBackInStockPopup() {
    const template = document.getElementById('LancasterBackInStockStyles');
    const popup = window.BIS && window.BIS.popup;
    if (!template || !popup) return;

    popup.ready.then(() => {
      const frame = document.getElementById('BIS_frame');
      const frameDocument = frame && frame.contentDocument;
      if (!frameDocument) return;
      if (!frameDocument.getElementById('LancasterBackInStockStylesheet')) {
        frameDocument.head.appendChild(template.content.cloneNode(true));
      }
      frameDocument.getElementById('container').classList.toggle('lancaster-bis-compact', window.matchMedia('(max-width: 749px) and (max-height: 650px)').matches);
      const content = document.getElementById('LancasterBackInStockContent');
      const variantData = document.getElementById('LancasterBackInStockVariants');
      const signup = frameDocument.querySelector('.signup-form-container');
      if (!content || !variantData || !signup) return;
      frameDocument.getElementById('bis-modal-title').textContent = content.dataset.title;
      frameDocument.getElementById('bis-modal-desc').textContent = content.dataset.description;
      frameDocument.getElementById('submit-btn').textContent = content.dataset.button;
      frameDocument.querySelector('.action-close').setAttribute('aria-label', content.dataset.close);
      if (!signup.querySelector('.lancaster-bis-product')) {
        signup.prepend(content.content.cloneNode(true));
      }
      const variants = frameDocument.getElementById('variants');
      const email = frameDocument.querySelector('input[type="email"]');
      [[variants, content.dataset.colorLabel], [email, content.dataset.emailLabel]].forEach(([field, text]) => {
        if (!field || field.parentElement.querySelector('.lancaster-bis-label')) return;
        if (!field.id) field.id = 'lancaster-bis-email';
        const label = frameDocument.createElement('label');
        label.className = 'lancaster-bis-label';
        label.htmlFor = field.id;
        label.textContent = text;
        field.before(label);
        field.setAttribute('aria-label', text);
      });
      if (email) {
        email.autocomplete = 'email';
        email.setAttribute('inputmode', 'email');
        email.required = true;
      }
      const productVariants = JSON.parse(variantData.textContent);
      const updateProduct = () => {
        const selected = variants && variants.selectedOptions[0];
        const variantId = selected ? selected.value : this.form.querySelector('[name="id"]').value;
        const variant = productVariants[variantId];
        signup.querySelector('.lancaster-bis-product img').src = variant.image;
        signup.querySelector('.lancaster-bis-swatch').innerHTML = variant.swatch;
        const color = signup.querySelector('.lancaster-bis-color');
        color.textContent = variant.color || (selected ? selected.textContent : '');
        const sku = signup.querySelector('.lancaster-bis-sku');
        sku.replaceChildren();
        sku.hidden = !variant.sku;
        if (variant.sku) {
          const reference = frameDocument.createElement('span');
          reference.textContent = variant.sku;
          sku.append(`${content.dataset.skuLabel} `, reference);
        }
      };
      updateProduct();
      if (variants && !variants.dataset.lancasterPreview) {
        variants.addEventListener('change', updateProduct);
        variants.dataset.lancasterPreview = 'true';
      }
      // Let mobile visitors read the popup before choosing to open the keyboard.
      const title = frameDocument.getElementById('bis-modal-title');
      title.tabIndex = -1;
      if (!frameDocument.body.dataset.lancasterFocus) {
        const focusHeading = () => {
          if (window.matchMedia('(max-width: 749px)').matches && frameDocument.body.classList.contains('fadein')) {
            title.focus({ preventScroll: true });
          }
        };
        new MutationObserver(focusHeading).observe(frameDocument.body, { attributes: true, attributeFilter: ['class'] });
        frameDocument.body.dataset.lancasterFocus = 'true';
        focusHeading();
      }
    });
  }

  onSubmitHandler(evt) {
    if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
      return;
    }
    
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) {
      return;
    }

    this.handleErrorMessage();

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);

    if (this.miniCart) {
      formData.append('sections', this.miniCart.getSectionsToRender().map((section) => section.id));
    }
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${theme.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
          this.error = true;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
        this.error = false;

        if (this.miniCart) {
          this.miniCart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    
    if (this.errorMessageWrapper) {
      if (this.hideErrors) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}
customElements.define('product-form', ProductForm);

class MobileStickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.mediaQuery = window.matchMedia(theme.config.mediaQueryProductMobile);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    this.handleScrollFallback = this.handleScrollFallback.bind(this);
    this.handleSwatchChange = this.handleSwatchChange.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.handleProductInfoLoaded = this.handleProductInfoLoaded.bind(this);
    this.handleVisualViewportChange = this.handleVisualViewportChange.bind(this);
  }

  connectedCallback() {
    this.mainButton = this.getMainButton();
    this.stickyButton = this.querySelector('[name="add"]');
    if (!this.mainButton || !this.stickyButton) return;

    this.setVisible(false);
    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.handleViewportChange);
    }
    else {
      this.mediaQuery.addListener(this.handleViewportChange);
    }
    this.addEventListener('change', this.handleSwatchChange);
    document.addEventListener('variant:change', this.handleVariantChange);
    document.addEventListener('productInfo:loaded', this.handleProductInfoLoaded);
    // An IntersectionObserver does not fire when the Safari toolbar collapses or
    // expands: the button's intersection with the layout viewport is unchanged,
    // only the visible region moved. Without this the bar's state goes stale at
    // exactly the moment the visible area changes.
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.handleVisualViewportChange);
      window.visualViewport.addEventListener('scroll', this.handleVisualViewportChange);
    }
    this.syncSwatchesFromMain();
    this.focusInitialSelectedSwatch();
    this.syncBackInStockProxy();
    this.handleViewportChange();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    this.observedButton = null;
    this.observedFooter = null;
    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener('change', this.handleViewportChange);
    }
    else {
      this.mediaQuery.removeListener(this.handleViewportChange);
    }
    window.removeEventListener('scroll', this.handleScrollFallback);
    window.removeEventListener('resize', this.handleScrollFallback);
    this.removeEventListener('change', this.handleSwatchChange);
    document.removeEventListener('variant:change', this.handleVariantChange);
    document.removeEventListener('productInfo:loaded', this.handleProductInfoLoaded);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.handleVisualViewportChange);
      window.visualViewport.removeEventListener('scroll', this.handleVisualViewportChange);
    }
    if (this.visibilityFrame) cancelAnimationFrame(this.visibilityFrame);
    if (this.initialSwatchFrame) cancelAnimationFrame(this.initialSwatchFrame);
    if (this.visibilityTimer) clearTimeout(this.visibilityTimer);
    if (this.galleryScrollTimer) clearTimeout(this.galleryScrollTimer);
  }

  getMainButton() {
    const mainFormId = this.dataset.mainFormId || `product-form-${this.dataset.section}`;
    const escapedFormId = window.CSS && CSS.escape ? CSS.escape(mainFormId) : mainFormId;
    return document.querySelector(`#${escapedFormId} [name="add"]`);
  }

  handleViewportChange() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
      this.observedButton = null;
      this.observedFooter = null;
    }
    window.removeEventListener('scroll', this.handleScrollFallback);
    window.removeEventListener('resize', this.handleScrollFallback);

    if (!this.mediaQuery.matches) {
      this.setVisible(false);
      return;
    }

    if ('IntersectionObserver' in window) {
      // The entries can describe a button that a variant re-render has since
      // replaced, so treat the observer purely as a cheap trigger and always
      // re-measure the button that is actually in the document. Trusting the
      // entries made the sticky bar appear alongside a perfectly visible main
      // add-to-cart, because the observed node was detached and therefore never
      // intersecting.
      this.observer = new IntersectionObserver(() => {
        this.updateVisibilityFromMainButton();
        // Fire on the crossings only; the decision itself is made by geometry
        // above, so intermediate ratios are of no interest.
      }, { threshold: [0, 1] });
      this.observeMainButton();
      this.observeFooter();
      this.queueVisibilityRefresh();
      return;
    }

    window.addEventListener('scroll', this.handleScrollFallback, { passive: true });
    window.addEventListener('resize', this.handleScrollFallback);
    this.handleScrollFallback();
  }

  handleScrollFallback() {
    this.updateVisibilityFromMainButton();
  }

  handleVisualViewportChange() {
    this.queueVisibilityRefresh();
  }

  get footer() {
    return document.querySelector('.shopify-section-footer');
  }

  isFooterInView() {
    const footer = this.footer;
    if (!footer) return false;

    const bounds = footer.getBoundingClientRect();
    if (bounds.height <= 0) return false;

    // Any part of the footer having entered the visible region is enough.
    return bounds.top < this.visibleViewportBounds.bottom;
  }

  // The footer is observed alongside the main button so that scrolling it into view
  // actually triggers a re-evaluation. Without this the IntersectionObserver only
  // fires on the button's own crossings, and the bar would sit over the footer until
  // something else happened to poke it.
  observeFooter() {
    if (!this.observer) return;
    const footer = this.footer;
    if (!footer || this.observedFooter === footer) return;
    if (this.observedFooter) this.observer.unobserve(this.observedFooter);
    this.observer.observe(footer);
    this.observedFooter = footer;
  }

  observeMainButton() {
    if (!this.observer || !this.mainButton) return;
    if (this.observedButton === this.mainButton && this.mainButton.isConnected) return;
    if (this.observedButton) this.observer.unobserve(this.observedButton);
    this.observer.observe(this.mainButton);
    this.observedButton = this.mainButton;
  }

  updateVisibilityFromMainButton() {
    this.mainButton = this.getMainButton() || this.mainButton;
    if (!this.mainButton || !this.stickyButton || !this.mediaQuery.matches) {
      this.setVisible(false);
      return;
    }

    // Follow the live button when a variant re-render swaps the form out.
    this.observeMainButton();

    // Once the footer is on screen the visitor has left the product behind, and a
    // floating buy button over the footer reads as stray chrome. Checked before the
    // reach test so it wins regardless of where the main button happens to be.
    if (this.isFooterInView()) {
      this.setVisible(false);
      return;
    }

    const bounds = this.mainButton.getBoundingClientRect();
    this.setVisible(this.isMainButtonOutOfReach(bounds));
  }

  // The region the visitor can actually see, in the same client coordinates that
  // getBoundingClientRect reports. window.innerHeight is the wrong reference on
  // mobile Safari: it does not describe the area left over under a toolbar that
  // paints on top of the page, so a main add-to-cart sitting behind the toolbar
  // was scored as visible (sticky bar hidden, neither button reachable) or a
  // fully visible one as half-hidden (sticky bar shown next to it — the reported
  // duplicate). visualViewport is that region, and it also shrinks for the
  // on-screen keyboard.
  get visibleViewportBounds() {
    const vv = window.visualViewport;
    if (!vv) {
      return { top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth };
    }
    return {
      top: vv.offsetTop,
      left: vv.offsetLeft,
      bottom: vv.offsetTop + vv.height,
      right: vv.offsetLeft + vv.width
    };
  }

  /* The bar exists for one situation: the real add-to-cart has scrolled up out of
     reach and the visitor needs a way back to it. So the question is "has the
     button gone past the top", not "how much of it can I see".

     A visible-area ratio answers the wrong question and misfires in both
     directions. It counted a button as hidden whenever it was merely clipped
     while still perfectly present — sitting below the fold on first load, or
     straddling the bottom browser chrome once Display Zoom shortens the viewport
     — which is exactly when the bar was appearing next to the very button it
     duplicates. Asking about the top edge instead removes the threshold, removes
     any dependence on the bar's own height, and removes the feedback loop where
     showing the bar changes the measurement that decides whether to show it. */
  isMainButtonOutOfReach(bounds) {
    if (!bounds || bounds.width <= 0 || bounds.height <= 0) return false;

    const view = this.visibleViewportBounds;

    // How much of the button is actually on screen. The bar is for whenever the
    // real add-to-cart is out of reach — that means below the fold just as much as
    // scrolled past, so both directions are measured the same way.
    //
    // The threshold is deliberately low. The duplicate this whole thing exists to
    // avoid is the bar sitting next to a button the visitor can plainly see and
    // tap; an earlier 0.65 caused exactly that, hiding nothing when 63% of the
    // button was visible under Display Zoom. At 0.25 the bar only appears once the
    // button is essentially gone, which also covers a button clipped by the bottom
    // browser chrome — still tappable, so still no bar.
    const onScreen = Math.min(bounds.bottom, view.bottom) - Math.max(bounds.top, view.top);
    const visibleRatio = Math.max(0, onScreen) / bounds.height;

    return visibleRatio < 0.25;
  }

  queueVisibilityRefresh() {
    if (!this.mediaQuery.matches) return;
    if (this.visibilityFrame) cancelAnimationFrame(this.visibilityFrame);
    if (this.visibilityTimer) clearTimeout(this.visibilityTimer);

    this.visibilityFrame = requestAnimationFrame(() => {
      this.visibilityFrame = null;
      this.updateVisibilityFromMainButton();
    });
    this.visibilityTimer = setTimeout(() => {
      this.visibilityTimer = null;
      this.updateVisibilityFromMainButton();
    }, 250);
  }

  handleSwatchChange(event) {
    const input = event.target.closest('.mobile-sticky-add-to-cart__swatch-input');
    if (!input || !input.checked) return;

    const optionValue = input.dataset.optionValue || input.value;
    const mainControl = this.getMainVariantControl(input.dataset.optionIndex, optionValue);
    if (!mainControl || mainControl.disabled) return;

    if (mainControl.matches('input[type="radio"]')) {
      if (mainControl.checked) return;
      mainControl.checked = true;
    }
    else if (mainControl.matches('select')) {
      if (mainControl.value === optionValue) return;
      mainControl.value = optionValue;
    }
    // Flagged rather than scrolled here so the scroll happens once the variant change
    // has actually landed, and so it stays scoped to changes made FROM this bar — a
    // change made in the main picker must not yank the page, since that picker is
    // already on screen.
    this.pendingGalleryScroll = true;

    mainControl.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleVariantChange(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
    this.syncSwatchesFromMain();
    this.syncBackInStockProxy();
    this.queueVisibilityRefresh();

    if (!this.pendingGalleryScroll) return;
    this.requestGalleryScroll();
  }

  handleProductInfoLoaded() {
    this.syncSwatchesFromMain();
    this.syncBackInStockProxy();
    this.queueVisibilityRefresh();

    // Also here, not only on variant:change. This fires once the section has actually
    // re-rendered, and the re-render is what was undoing the earlier scroll — from
    // deep in the reviews the page ended up part-way instead of at the gallery.
    if (this.pendingGalleryScroll) this.requestGalleryScroll();
  }

  // Glides up, with an instant backstop only if the glide did not take.
  //
  // The animation is what the visitor should see, so it is started first. But a
  // smooth scroll is fragile here: the variant re-render lands moments later and can
  // cancel it mid-flight, which is what previously left the page part-way up. So the
  // trailing pass checks where we actually ended up and only snaps if the glide
  // failed — if it worked, there is nothing left to do and no visible second jump.
  // The flag is only cleared by the trailing pass, so a late productInfo:loaded
  // cannot yank a page the visitor has since scrolled away from.
  requestGalleryScroll() {
    // A glide is already running — let it finish. This is called from both
    // variant:change and productInfo:loaded, and re-issuing scrollTo mid-animation
    // restarts it, which shows up as a stutter part-way up.
    if (this.galleryScrollTimer) return;

    this.scrollToGallery({ smooth: true });

    this.galleryScrollTimer = setTimeout(() => {
      this.galleryScrollTimer = null;
      this.pendingGalleryScroll = false;
      // Already there (or as good as) — the glide worked, leave it alone.
      if (window.scrollY <= 4) return;
      this.scrollToGallery();
    }, 1100);
  }

  syncBackInStockProxy() {
    if (!this.stickyButton) return;

    if (this.stickyButton.dataset.backInStockProxy === 'true') {
      if (this.mainButton && this.mainButton.dataset.backInStockProxy === 'true') {
        this.stickyButton.innerHTML = this.mainButton.innerHTML;
      }
      return;
    }

    if (this.stickyButton.disabled && this.stickyButton.textContent.trim() === theme.variantStrings.soldOut) {
      this.stickyButton.type = 'button';
      this.stickyButton.removeAttribute('disabled');
      this.stickyButton.removeAttribute('aria-disabled');
      this.stickyButton.dataset.backInStockProxy = 'true';
      this.stickyButton.innerHTML = this.mainButton.innerHTML;
    }
  }

  getMainVariantControl(optionIndex, value) {
    if (!optionIndex) return null;

    const section = document.getElementById(`shopify-section-${this.dataset.section}`) || document;
    const radioWrapper = section.querySelector(`variant-radios .variant-input-wrapper[data-option-index="${optionIndex}"]`);
    if (radioWrapper) {
      return Array.from(radioWrapper.querySelectorAll('input[type="radio"]')).find((input) => input.value === value);
    }

    const selectWrapper = section.querySelector(`variant-selects .variant-input-wrapper[data-option-index="${optionIndex}"]`);
    const select = selectWrapper && selectWrapper.querySelector('select');
    return select || null;
  }

  syncSwatchesFromMain() {
    this.querySelectorAll('.mobile-sticky-add-to-cart__swatch-input').forEach((input) => {
      const optionValue = input.dataset.optionValue || input.value;
      const mainControl = this.getMainVariantControl(input.dataset.optionIndex, optionValue);
      input.checked = !!mainControl && (
        mainControl.matches('input[type="radio"]') ? mainControl.checked : mainControl.value === optionValue
      );
      // Reuse the main picker's availability state and shared swatch styling.
      const mainOption = mainControl && (mainControl.matches('select')
        ? Array.from(mainControl.options).find((option) => option.value === optionValue)
        : mainControl);
      input.disabled = !!mainOption && mainOption.disabled;
      input.toggleAttribute('data-crossout', !!mainOption && mainOption.hasAttribute('data-crossout'));
    });
  }

  // Reveal the server-selected colour once on direct page load. Later variant changes
  // deliberately do not recenter the strip, because doing so would fight manual scroll.
  focusInitialSelectedSwatch() {
    if (this.initialSwatchFrame) cancelAnimationFrame(this.initialSwatchFrame);

    this.initialSwatchFrame = requestAnimationFrame(() => {
      this.initialSwatchFrame = null;
      const input = this.querySelector('.mobile-sticky-add-to-cart__swatch-input:checked');
      const item = input && input.closest('li');
      const strip = input && input.closest('.product-form__input-wrapper');
      if (!item || !strip || strip.clientWidth <= 0) return;

      const centeredLeft = item.offsetLeft - (strip.clientWidth - item.offsetWidth) / 2;
      const maxLeft = Math.max(0, strip.scrollWidth - strip.clientWidth);
      strip.scrollLeft = Math.min(maxLeft, Math.max(0, centeredLeft));
    });
  }

  // Picking a colour here changes the gallery, which is off-screen at the time — so
  // return the visitor to it, or they change variant and appear to see nothing happen.
  scrollToGallery({ smooth = false } = {}) {
    // Straight to the top of the page, deliberately, rather than measuring the
    // gallery. On a PDP the gallery IS the top, so this needs no geometry and cannot
    // be thrown off by the things that defeated every measured approach tried here:
    // getBoundingClientRect().top + scrollY (viewport-relative), the offsetParent
    // chain, and scrollIntoView on the #ProductImages anchor — each landed somewhere
    // different because that anchor carries `position: relative; top: -7rem`, which
    // displaces its rect 70px from its layout position. 0 has nothing to compute.
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const behavior = smooth && !(reducedMotion && reducedMotion.matches) ? 'smooth' : 'auto';

    window.scrollTo({ top: 0, behavior });
  }

  setVisible(visible) {
    this.classList.toggle('is-visible', visible);
    this.setAttribute('aria-hidden', visible ? 'false' : 'true');
    this.inert = !visible;
    if (this.stickyButton) this.stickyButton.tabIndex = visible ? 0 : -1;
    if (visible) {
      this.syncSwatchesFromMain();
    }
  }
}
customElements.define('mobile-sticky-add-to-cart', MobileStickyAddToCart);

class DeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.update();
  }

  update() {
    if (this.dataset.estimateMode !== 'business-days') return;

    const target = this.querySelector('[data-delivery-estimate-date]');
    const businessDays = parseInt(this.dataset.businessDays || '3', 10);
    if (!target || !Number.isFinite(businessDays) || businessDays < 1) return;

    const deliveryDate = this.addBusinessDays(new Date(), businessDays);
    const locale = document.documentElement.lang || window.Shopify?.locale || 'fr-FR';
    target.textContent = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(deliveryDate);
  }

  addBusinessDays(date, businessDays) {
    const result = new Date(date);
    result.setHours(12, 0, 0, 0);

    let addedDays = 0;
    while (addedDays < businessDays) {
      result.setDate(result.getDate() + 1);

      const dayOfWeek = result.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays += 1;
      }
    }

    return result;
  }
}
customElements.define('delivery-estimate', DeliveryEstimate);

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    setTimeout(() => {
      const quantity = parseInt(this.dataset.quantity);
      this.style.setProperty('--progress-bar-width', `${quantity * 100 / 30}%`);
    }, 1e3);
  }
}
customElements.define('progress-bar', ProgressBar);

class FormState extends HTMLElement {
  constructor() {
    super();

    this.formInputs = this.querySelectorAll('input,select,textarea');
    this.form = this.querySelector('form');

    this.formInputs.forEach((input) => {
      input.addEventListener('input', this.onInputChange.bind(this));
      input.addEventListener('blur', this.onInputChange.bind(this));
    });

    if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onInputChange(event) {
    this.handleInputCheck(event.target);
  }

  onSubmitHandler(event) {
    let valid = !0;

    this.formInputs.forEach((input) => {
      if (!this.handleInputCheck(input)) {
        valid = !1;
      }
    });

    if (!valid) {
      event.preventDefault();
      return;
    }
  }

  handleInputCheck(input) {
    if (input.classList.contains('required') || input.getAttribute('required')) {

      if (input.value.length === 0 || input.value === input.dataset.empty) {
        input.classList.remove('valid');
        input.classList.add('invalid');
        
        return !1;
      }
      else {
        input.classList.remove('invalid');
        input.classList.add('valid');

        return !0;
      }
    }

    return !0;
  }
}
customElements.define('form-state', FormState);

class ListMenuItem extends HTMLElement {
  constructor() {
    super();

    this.listMenuHover = this.closest('menu-drawer').querySelector('list-menu-hover');

    this.addEventListener('mouseenter', () => {
      this.listMenuHover.open({
        title: this.dataset.title,
        url: this.dataset.url,
        image: this.dataset.image,
        description: this.dataset.description
      });
    });
  }
}
customElements.define('list-menu-item', ListMenuItem);

class ListMenuHover extends HTMLElement {
  constructor() {
    super();
  }

  open(obj) {
    let html = '';
    const opened = obj.image.length > 0 || obj.description.length > 0;

    if (opened) {
      html += `<a href="${obj.url}" class="hover-collection${obj.image.length > 0 ? '' : ' hover-collection--no-image'}">`;
        html += '<figure class="hover-collection__image"' + (obj.image.length > 0 ? `style="background-image:url(${obj.image})"` : '') + '></figure>';
        html += '<div class="hover-collection__content">'
          html += `<span class="hover-collection__title h4">${obj.title}</span>`;
          html += obj.description.length > 0 ? `<div class="hover-collection__description">${obj.description}</div>` : '';
        html += '</div>';
      html += '</a>';
    }

    this.innerHTML = html;
  }

  close() {
    this.innerHTML = '';
  }
}
customElements.define('list-menu-hover', ListMenuHover);

class TransparentHeader extends HTMLElement {
  constructor() {
    super();

    const header = document.querySelector('.shopify-section-header');

    header.classList.add('transparent-header');
    if (this.dataset.showSeparator == 'true') {
      header.classList.add('transparent-separator');
    }
  }
}
customElements.define('transparent-header', TransparentHeader);

class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.addEventListener('click', this.onClickHandler.bind(this));
    this.addEventListener('keydown', this.onKeyDownHandler.bind(this));
  }

  onKeyDownHandler(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    this.click();
  }

  onClickHandler() {
    if (this.hasAttribute('disabled') || this.getAttribute('aria-disabled') === 'true') return;

    const variantId = this.dataset.variantId;

    if (variantId) {
      if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
        Shopify.postLink(theme.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1
          },
        });
        return;
      }

      this.setAttribute('disabled', true);
      this.setAttribute('aria-disabled', 'true');
      this.classList.add('loading');
      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
             document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description
                }
              }));
           }
           else {
            this.miniCart && this.miniCart.renderContents(parsedState);

             document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState
              }
            }));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.classList.remove('loading');
          this.removeAttribute('disabled');
          this.removeAttribute('aria-disabled');
        });
    }
  }
}
customElements.define('add-to-cart', AddToCart);

class PriceMoney extends HTMLElement {
  constructor() {
    super();

    if (this.shouldInit()) {
      this.init();
    }
  }

  shouldInit() {
    if (document.body.dataset.priceSuperscript === undefined) {
      return false;
    }  

    const moneyFormat = theme.shopSettings.moneyFormat.toLowerCase();
    if (moneyFormat.indexOf('class=') !== -1) {
      return false;
    }
    
    return true;
  }

  init() {
    const currencies_using_comma_decimals = 'ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND'.split(',');
    const symbol = theme.shopSettings.moneyFormat.replace(/\{{.*}}/, '').trim();
    const bdi = this.querySelector('bdi');
    const price = bdi.textContent.replace(theme.shopSettings.isoCode,'');
    let html = price.replace(' ', '');
    let money_symbol_decimal = '.';
    if (currencies_using_comma_decimals.includes(theme.shopSettings.isoCode)) {
      money_symbol_decimal = ',';
    }
    if (price.includes(money_symbol_decimal)) {
      if (price.lastIndexOf(symbol) + symbol.length === price.length) {
        const price_without_symbol = price.slice(0, price.lastIndexOf(symbol));
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
        const decimal = price_without_symbol.replace(price_without_decimal, '').trim();
        html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`);
      }
      else {
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
        const decimal = price.replace(price_without_decimal, '').trim();
        html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`);
      }
    }
    html = html.replace(symbol, `<span class="price__prefix">${symbol}</span>`);
    if(theme.shopSettings.currencyCode){
       html = html + " " + theme.shopSettings.isoCode;
    }
    bdi.innerHTML = html;
  }
}
customElements.define('price-money', PriceMoney);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      small: this.querySelector('.slideshow__left'),
      content: this.querySelector('.slideshow__content'),
      large: this.querySelector('.slideshow__right')
    }
    this.settings = {
      autorotate: this.dataset.autorotate == 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      slidesSmall: this.elements.small.querySelectorAll('.slideshow__image'),
      slidesLarge: this.elements.large.querySelectorAll('.slideshow__image')
    };

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
    this.matchMedia();
  }

  init() {
    setTimeout(() => {
      this.flickitySmall = new Flickity(this.elements.small, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: false,
        setGallerySize: false,
        autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
      });

      this.flickityContent = new Flickity(this.elements.content, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        draggable: true,
        asNavFor: this.elements.small,
        adaptiveHeight: true,
        setGallerySize: false,
        arrowShape: 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
        on: {
          ready: () => {
            const prevNextButtons = this.querySelectorAll('.flickity-button');
            if (prevNextButtons) {
              prevNextButtons.forEach((button) => {
                button.setAttribute('tabindex', '-1');
              });
            }
          }
        }
      });

      this.flickityLarge = new Flickity(this.elements.large, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        setGallerySize: false,
        asNavFor: this.elements.content,
        dragThreshold: 10
      });

      // Any arrow click or drag STOPS (not pauses) the autoplaying player via
      // uiChange, so the rotation never came back. Restart it once the slide
      // settles after every interaction.
      if (this.settings.autorotate) {
        const resumeAutoplay = () => this.flickitySmall && this.flickitySmall.playPlayer();
        [this.flickitySmall, this.flickityContent, this.flickityLarge].forEach((instance) => {
          if (instance) instance.on('settle', resumeAutoplay);
        });
      }

      this.bindEvents();
    });
  }

  bindEvents() {
    this.flickitySmall.on('scroll', () => {
      this.flickitySmall.slides.forEach((slide, i) => {
        const flickity = this.flickitySmall;
        const image = this.settings.slidesSmall[i];
        let x = 0;

        if (image) {
          if( 0 === i ) {
            x = Math.abs( flickity.x ) > flickity.slidesWidth ? ( flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + flickity.x );
          }
          else if( i === flickity.slides.length - 1 ) {
            x = Math.abs( flickity.x ) + flickity.slides[i].outerWidth < flickity.slidesWidth ? ( slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth ) : ( slide.target + flickity.x );
          }
          else {
            x = slide.target + flickity.x;
          }
          
          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * ( -1 / 2 ) + 'px)';
          }
        }
      });
    });

    this.flickityLarge.on('scroll', () => {
      this.flickityLarge.slides.forEach((slide, i) => {
        const flickity = this.flickityLarge;
        const image = this.settings.slidesLarge[i];
        let x = 0;

        if (image) {
          if( 0 === i ) {
            x = Math.abs( flickity.x ) > flickity.slidesWidth ? ( flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + flickity.x );
          }
          else if( i === flickity.slides.length - 1 ) {
            x = Math.abs( flickity.x ) + flickity.slides[i].outerWidth < flickity.slidesWidth ? ( slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth ) : ( slide.target + flickity.x );
          }
          else {
            x = slide.target + flickity.x;
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * ( -1 / 2 ) + 'px)';
          }
        }
      });
    });

    this.elements.content.querySelector('.flickity-button.next').addEventListener('click', () => {
      this.flickitySmall && this.flickitySmall.next();
      this.stopPlayer();
    });

    this.elements.content.querySelector('.flickity-button.previous').addEventListener('click', () => {
      this.flickitySmall && this.flickitySmall.previous();
      this.stopPlayer();
    });

    this.elements.content.querySelectorAll('.flickity-page-dot').forEach((button) => {
      button.addEventListener('click', () => {
        this.stopPlayer();
      });
    });

    let currentIndex = null,
      swipeDirection = null;
  
    // Detect swipe direction
    this.flickityLarge.on('dragMove',  (_event, _pointer, moveVector) => {
      currentIndex = this.flickityLarge.selectedIndex;
      swipeDirection = this.getSwipeDirection(moveVector);

      this.stopPlayer();
    });
    
    // Do stuff based on a successful swipe and it's direction
    this.flickityLarge.on('dragEnd', () => {
      if (this.flickityLarge.selectedIndex !== currentIndex) {
        
        if (swipeDirection === 'left') {
          this.flickitySmall.next();
        }
        else {
          this.flickitySmall.previous();
        }
      }
    });
  }

  stopPlayer() {
    if (this.settings.autorotate) {
      this.flickitySmall && this.flickitySmall.stopPlayer();
    }
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? 'right' : 'left';
  }

  matchMedia() {
    document.addEventListener('matchSmall', () => {
      this.unload();
      this.init();
    });

    document.addEventListener('unmatchSmall', () => {
      this.unload();
      this.init();
    });
  }

  unload() {
    if (this.flickitySmall && typeof this.flickitySmall.destroy === 'function') {
      this.flickitySmall.destroy();
    }
    if (this.flickityContent && typeof this.flickityContent.destroy === 'function') {
      this.flickityContent.destroy();
    }
    if (this.flickityLarge && typeof this.flickityLarge.destroy === 'function') {
      this.flickityLarge.destroy();
    }
  }
}
customElements.define('slideshow-component', SlideshowComponent);

class TestimonialsComponent extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.slider == 'true') {
      this.settings = {
        autorotate: this.dataset.autorotate == 'true',
        autorotateSpeed: parseInt(this.dataset.autorotateSpeed)
      };
      this.slider = this.querySelector('.testimonial__list');
      this.previews = this.querySelector('.testimonial__previews');

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
      theme.initWhenVisible({
        element: this,
        callback: this.update.bind(this),
        threshold: 0
      });
    }
  }

  init() {
    setTimeout(() => {
      if (this.slider) {
        this.flickity = new Flickity(this.slider, {
          accessibility: false,
          rightToLeft: theme.config.rtl,
          prevNextButtons: true,
          arrowShape: 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
          pageDots: false,
          wrapAround: true,
          draggable: true,
          cellAlign: 'center',
          autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
          pauseAutoPlayOnHover: true,
          asNavFor: this.previews
        });
      }

      this.flickityNav = new Flickity(this.previews, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: this.flickity ? false : true,
        arrowShape: this.flickity ? '' : 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
        pageDots: false,
        wrapAround: true,
        selectedAttraction: 0.2,
        friction: 0.8,
        adaptiveHeight: true,
      });

      this.flickityNav.previous();
      if (this.settings.autorotate) {
        this.flickity.pausePlayer();
      }

      this.flickity && this.flickity.on('staticClick', (_event, _pointer, _cellElement, cellIndex) => {
        if (typeof cellIndex == 'number') {
          this.flickityNav.select(cellIndex);
        }
      });
      
      // Do stuff based on a successful swipe and it's direction
      this.flickity && this.flickity.on('change', (index) => {
        this.flickityNav.select(index);
      });
    });
  }

  update() {
    setTimeout(() => {
      if (this.flickity && this.flickityNav) {
        this.flickityNav.next();
        if (this.settings.autorotate) {
          this.flickity.unpausePlayer();
        }
      }
    }, 300);
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? 'right' : 'left';
  }
}
customElements.define('testimonials-component', TestimonialsComponent);

class UseAnimate extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('animate', '');
  }
}
customElements.define('use-animate', UseAnimate);

class AnimateSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.getOffsetTop(this)) {
      window.requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.setAttribute('animate', '');
  }

  reset() {
    this.removeAttribute('animate');
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while(element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}
customElements.define('animate-sticky', AnimateSticky);

class LookbookComponent extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    const hotspots = this.querySelectorAll('.look__hotspot');
    hotspots.forEach((hotspot) => {
      hotspot.classList.add('is-active');
    });

    setTimeout(() => {
      hotspots.forEach((hotspot) => {
        hotspot.classList.remove('is-active');
      });
    }, 3e3);
  }
}
customElements.define('lookbook-component', LookbookComponent);

class TabCollage extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.tab-collage__heading').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if (this.dataset.accordion === undefined) {
      this.querySelectorAll('.tab-collage__heading').forEach(
        (button) => button.addEventListener('mouseover', this.onButtonClick.bind(this))
      );
    }
  }

  onButtonClick(event) {
    const target = event.target;
    if (target.classList.contains('is-active')) {
      if (this.dataset.accordion !== undefined) {
        target.classList.remove('is-active');
      }
      return;
    }

    this.pauseAllMedia();

    this.querySelectorAll('[data-block-id]').forEach((button) => {
      if (target.dataset.blockId === button.dataset.blockId) {
        button.classList.add('is-active');
      }
      else {
        button.classList.remove('is-active');
      }
    });
  }

  pauseAllMedia() {
    this.querySelectorAll('video-section[data-type="youtube"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('video-section[data-type="vimeo"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('tab-collage', TabCollage);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('.product-countdown');
    this.date = new Date(Date.parse(this.dataset.date)).getTime();

    if (isNaN(this.date)) {
      this.date = new Date(this.dataset.date.replace(/-/g, "/")).getTime();

      if (isNaN(this.date)) {
        this.unload();
        return;
      }
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.timer();
    this.dataset.interval = setInterval(this.timer.bind(this), 1000);
  }

  timer() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now);

    if (timeDifference < 0) {
      this.unload();
      return;
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;

    const days = Math.floor(timeDifference / (secondsInADay) * 1);
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);

    if (this.dataset.compact == 'true') {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}${theme.dateStrings.d}</span></div>` : '';
      const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : '0' + hours}:${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}</span></div>`;
  
      this.innerHTML = dayHTML + otherHTML;
    }
    else {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}</span> ${days == 1 ? theme.dateStrings.day : theme.dateStrings.days}</div>` : '';
      const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${hours == 1 ? theme.dateStrings.hour : theme.dateStrings.hours}</div>`;
      const minHTML = `<div class="countdown__item"><span>${mins}</span> ${mins == 1 ? theme.dateStrings.minute : theme.dateStrings.minutes}</div>`;
      const secHTML = `<div class="countdown__item"><span>${secs}</span> ${secs == 1 ? theme.dateStrings.second : theme.dateStrings.seconds}</div>`;

      this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
    }
  }

  unload() {
    if (this.dataset.interval) {
      clearInterval(this.dataset.interval);
    }

    this.classList.add('hidden');
    if (this.parent) {
      this.parent.classList.add('hidden');
    }
  }
}
customElements.define('countdown-timer', CountdownTimer);

class GMap extends HTMLElement {
  constructor() {
    super();

    if (!this.dataset.apiKey || !this.dataset.mapAddress) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.prepMapApi.bind(this),
      threshold: 200
    });
  }

  prepMapApi() {
    this.loadScript().then(this.initMap.bind(this));
  }

  loadScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.dataset.apiKey;
    });
  }

  initMap() {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: this.dataset.mapAddress }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        if (Shopify.designMode) {}
      }
      else {
        const mapOptions = {
          zoom: parseInt(this.dataset.zoom),
          center: results[0].geometry.location,
          draggable: true,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true
        };

        const map = new google.maps.Map(this, mapOptions), center = map.getCenter();

        map.setCenter(center);

        const icon = {
          path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
          fillColor: this.dataset.markerColor,
          fillOpacity: 1,
          anchor: new google.maps.Point(15, 55),
          strokeWeight: 0,
          scale: 0.6
        };

        new google.maps.Marker({
          map: map,
          position: map.getCenter(),
          icon: icon
        });

        const styledMapType = new google.maps.StyledMapType(JSON.parse(this.parentNode.querySelector('[data-gmap-style]').innerHTML));

        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        google.maps.event.addDomListener(window, 'resize', function () {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
        });
      }
    });
  }
}
customElements.define('g-map', GMap);

class RelatedButtons extends HTMLElement {
  constructor() {
    super();

    if(!document.querySelector(this.dataset.scrollto)) {
      this.classList.add('hidden');
      return;
    }

    window.addEventListener('scroll', this.checkListener.bind(this));
    this.querySelectorAll('a').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  checkListener() {
    const element = document.querySelector(this.dataset.scrollto);
    const show = window.scrollY >= element.offsetTop - element.clientHeight;

    if (show) {
      this.classList.add('is-flipped');
    } else {
      this.classList.remove('is-flipped');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.target;
    const scrollIntoView = document.querySelector(target.getAttribute('href'));

    scrollIntoView.scrollIntoView({behavior: "smooth"});
  }
}
customElements.define('related-buttons', RelatedButtons);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    
    // We save the product ID in local storage to be eventually used for recently viewed section
    if (isStorageSupported('local')) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = 'beyours:recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // By keeping only the 4 most recent
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 5)));
    }
  }
}
customElements.define('product-recently-viewed', ProductRecentlyViewed);

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('recently-viewed-products');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  getQueryString() {
    const cookieName = 'beyours:recently-viewed';
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
    if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
    }
    return items.map((item) => "id:" + item).slice(0, 4).join(" OR ");
  }
}
customElements.define('recently-viewed-products', RecentlyViewedProducts);

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.background = this.dataset.initMode !== 'template';
    this.loop = this.dataset.loop;
    // The first video hero is the page's LCP media. Waiting for the generic
    // visibility observer adds an avoidable extra paint: first the poster,
    // then observer setup, then source attachment and a video reload. Start
    // only the visible first hero immediately; hidden responsive siblings and
    // every later video keep the normal lazy behaviour.
    this.priorityHero = this.matches('#MainContent > .shopify-section:first-child [data-video-hero]')
      && getComputedStyle(this).display !== 'none';

    if (this.background && !this.priorityHero) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
    else {
      this.init();
    }
  }

  init() {
    this.parentSelector = this.dataset.parent || '.media-wrapper';
    this.parent = this.closest(this.parentSelector);

    switch(this.dataset.type) {
      case 'youtube':
        this.initYoutubeVideo();
        break;

      case 'vimeo':
        this.initVimeoVideo();
        break;

      case 'mp4':
        this.initMp4Video();
        break;
    }
  }

  initYoutubeVideo() {
    this.setAsLoading();
    this.loadScript('youtube').then(this.setupYoutubePlayer.bind(this));
  }

  initVimeoVideo() {
    this.setAsLoading();
    this.loadScript('vimeo').then(this.setupVimeoPlayer.bind(this));
  }

  initMp4Video() {
    this.player = this.querySelector('video');

    if (this.player) {
      if (this.priorityHero) this.player.preload = 'auto';
      if (this.player.classList.contains('lazy')) {
        for (var source in this.player.children) {
          var videoSource = this.player.children[source];
          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
            videoSource.src = videoSource.dataset.src;
          }
        }
        this.player.load();
        this.player.classList.remove("lazy");
      }
      
      // Force muted on Firefox
      if(this.player.getAttribute('muted')) {
        this.player.muted = true;
      }
      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.playMp4Video();
          } else {
            this.stopMp4Video();
          }
        });
      }, {rootMargin: '0px 0px 50px 0px'});

      observer.observe(this.player);

      this.mp4ButtonPlay = this.querySelector('.button--play');
      this.mp4PlayClass = 'is-playing';
      if(this.mp4ButtonPlay) {
        this.mp4ButtonPlay.addEventListener('click', this.toggleMp4VideoState.bind(this));
        const updatePlayLabel = () => {
          const label = this.player.paused ? this.mp4ButtonPlay.dataset.playLabel : this.mp4ButtonPlay.dataset.pauseLabel;
          if (label) this.mp4ButtonPlay.setAttribute('aria-label', label);
        };
        updatePlayLabel();

        this.player.addEventListener('ended', () => {
          this.mp4ButtonPlay.classList.remove(this.mp4PlayClass);
          updatePlayLabel();
        })
  
        this.player.addEventListener('pause', () => {
          this.mp4ButtonPlay.classList.remove(this.mp4PlayClass);
          updatePlayLabel();
        })
  
        this.player.addEventListener('play', () => {
          this.mp4ButtonPlay.classList.add(this.mp4PlayClass);
          updatePlayLabel();
        })
      }

      this.mp4ButtonSound = this.querySelector('.button--sound');
      this.mp4SoundClass = 'is-muted';
      if(this.mp4ButtonSound) {
        this.mp4ButtonSound.addEventListener('click', this.toggleMp4VideoSound.bind(this));
      }
    }
  }

  toggleMp4VideoState() {
    if(this.player.paused) {
      this.playMp4Video();
    } else {
      this.stopMp4Video();
    }
  }

  toggleMp4VideoSound(event) {
    var button = event.currentTarget;
    this.player.muted ? button.classList.remove(this.mp4SoundClass) : button.classList.add(this.mp4SoundClass);
    this.player.muted = !this.player.muted;
    const label = this.player.muted ? button.dataset.unmuteLabel : button.dataset.muteLabel;
    if (label) button.setAttribute('aria-label', label);
  }

  playMp4Video() {
    const promise = this.player.play();

    // Edge does not return a promise (video still plays)
    if (typeof promise !== 'undefined') {
      promise.then(function() {
        // playback normal
      }.bind(this)).catch(function() {
        // this.player.setAttribute('controls', '');
        this.mp4ButtonPlay.classList.remove(this.mp4PlayClass);
      });
    }
  }

  stopMp4Video() {
    if (this.player && typeof this.player.pause === 'function') {
      this.player.pause();
    }
  }

  loadScript(videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = videoType === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
    });
  }

  setAsLoading() {
    this.parent.setAttribute('loading', true);
  }

  setAsLoaded() {
    this.parent.removeAttribute('loading');
    this.parent.setAttribute('loaded', true);
  }

  setupYoutubePlayer() {
    const videoId = this.dataset.videoId;
    
    const playerInterval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const element = document.createElement('div');
          this.appendChild(element);

          this.player = new YT.Player(element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              controls: !this.background,
              fs: !this.background,
              rel: 0,
              height: '100%',
              width: '100%',
              iv_load_policy: 3,
              html5: 1,
              loop: this.loop == '1' ? 1 : 0,
              playlist: videoId,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this)
            }
          });
          clearInterval(playerInterval);
        });
      }
    }, 50);
  }

  onYoutubeReady() {
    this.iframe = this.querySelector('iframe'); // iframe once YT loads
    this.iframe.setAttribute('tabindex', '-1');

    this.background && this.player.mute();
    if (typeof this.player.playVideo === 'function') this.player.playVideo();

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        entry.isIntersecting ? this.youtubePlay() : this.youtubePause();
      });
    }, {rootMargin: '0px 0px 50px 0px'});

    observer.observe(this.iframe);
  }

  onYoutubeStateChange(event) {
    switch (event.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (this.attemptedToPlay) {
          this.setAsLoaded();
          this.closest('.banner').classList.add('video-interactable');
        }
        break;
      case 0: // ended, loop it
        this.youtubePlay();
        break;
      case 1: // playing
        this.setAsLoaded();
        break;
      case 3: // buffering
        this.attemptedToPlay = true;
        break;
    }
  }

  youtubePlay() {
    if (this.background && this.player && typeof this.player.playVideo === 'function') {
      this.player.playVideo();
    }
  }

  youtubePause() {
    if (this.background && this.player && typeof this.player.pauseVideo === 'function') {
      this.player.pauseVideo();
    }
  }

  setupVimeoPlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: true,
          autopause: false,
          background: this.background,
          controls: !this.background,
          loop: this.loop == '1' ? true : false,
          playlist: videoId,
          height: '100%',
          width: '100%'
        });
        this.player.ready().then(this.onVimeoReady.bind(this));

        clearInterval(playerInterval);
      }
    }, 50);
  }

  onVimeoReady() {
    this.iframe = this.querySelector('iframe');
    this.iframe.setAttribute('tabindex', '-1');

    this.background && this.player.setMuted(true);

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.vimeoPlay();
        } else {
          this.vimeoPause();
        }
      });
    }, {rootMargin: '0px 0px 50px 0px'});

    observer.observe(this.iframe);
  }

  vimeoPlay() {
    if (this.background && this.player && typeof this.player.play === 'function') {
      this.player.play();
    }
  }

  vimeoPause() {
    if (this.background && this.player && typeof this.player.pause === 'function') {
      this.player.pause();
    }
  }
}
customElements.define('video-section', VideoSection);

class BundleProduct extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      souldout: 'price--sold-out',
      onsale: 'price--on-sale',
      nocompare: 'price--no-compare'
    };

    this.addToCart = this.querySelector('add-to-cart');
    this.price = this.querySelector('.price');
    this.variants = this.querySelector('select');
    if (this.variants) {
      this.variants.addEventListener('change', this.onSelectChange.bind(this));
    }
  }

  onSelectChange(event) {
    const variants = event.target;
    const variant = variants.options[variants.selectedIndex];
    const compare_at_price = parseInt(variant.dataset.compare_at_price || 0);
    const price = parseInt(variant.dataset.price || 0);
    const available = variant.dataset.available === 'true';
    const price_varies = variants.dataset.price_varies === 'true';
    const compare_at_price_varies = variants.dataset.compare_at_price_varies === 'true';

    // Remove classes
    this.price.classList.remove(this.classes.souldout);
    this.price.classList.remove(this.classes.onsale);
    this.price.classList.remove(this.classes.nocompare);

    // Add classes
    if (available === false) {
      this.price.classList.add(this.classes.souldout);
    }
    else if (compare_at_price > price && available) {
      this.price.classList.add(this.classes.onsale);
    }
    if (price_varies == false && compare_at_price_varies) {
      this.price.classList.add(this.classes.nocompare);
    }

    // Change price
    const price__regular = this.querySelector('.price__regular');
    price__regular.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoneyWithoutTrailingZeros(price, theme.shopSettings.moneyFormat)}</bdi></price-money>`;

    const price__sale = this.querySelector('.price__sale');
    price__sale.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoneyWithoutTrailingZeros(compare_at_price, theme.shopSettings.moneyFormat)}</bdi></price-money>`;
    price__sale.querySelector('.price-item--sale').innerHTML = `<price-money><bdi>${theme.Currency.formatMoneyWithoutTrailingZeros(price, theme.shopSettings.moneyFormat)}</bdi></price-money>`;

    // Change variant id
    if (this.addToCart) {
      this.addToCart.dataset.variantId = variant.value;
    }
  }
}
customElements.define('bundle-product', BundleProduct);

class BundleProducts extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
    };

    this.miniCart = document.querySelector('mini-cart');
    this.button = this.querySelector('button');
    if (this.button) this.button.addEventListener('click', this.onButtonClick.bind(this));

    this.blocks = this.querySelectorAll('[data-block-id]');
    this.blocks.forEach((block) => block.addEventListener('mouseenter', this.onEnterHandler.bind(this)));
    this.blocks.forEach((block) => block.addEventListener('mouseleave', this.onLeaveHandler.bind(this)));
  }

  onEnterHandler(event) {
    this.classList.add(this.classes.hover);

    const target = event.target;
    const blockId = target.dataset.blockId;
    this.blocks.forEach((block) => {
      if (target.nodeName === 'BUNDLE-PRODUCT') {
        if (block.nodeName === 'BUNDLE-PRODUCT') {
          block.classList.add(this.classes.active);
          return;
        }
      }
      if (block.dataset.blockId === blockId) {
        block.classList.add(this.classes.active);
      }
    });
  }

  onLeaveHandler() {
    this.classList.remove(this.classes.hover);
    this.blocks.forEach((block) => block.classList.remove(this.classes.active));
  }

  onButtonClick(event) {
    event.preventDefault();

    const ids = this.querySelectorAll('[name="id"]');
    const items = {
      items: [...ids].map((e => e.value)).map((e => ({
        id: e,
        quantity: 1
      })))
    };

    if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
      Shopify.postLink2(theme.routes.cart_add_url, {
        parameters: {
          ...items
        }
      });
      return;
    }

    this.handleErrorMessage();

    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');
    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

    const body = JSON.stringify({
      ...items,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (response.status === 422) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: response.description
            }
          }));
        }
        else {
          this.miniCart && this.miniCart.renderContents(response);

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: response
            }
          }));
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    
    if (this.errorMessageWrapper) {
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}
customElements.define('bundle-products', BundleProducts);

class ShopTheLook extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.blockCount == 1) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    this.products = this.querySelector('.image-with-text__products');

    this.blocks = this.querySelectorAll('lookbook-component [data-block-index]');
    this.blocks.forEach((block) => block.addEventListener('mouseenter', this.onEnterHandler.bind(this)));

    this.initSlider();
  }

  onEnterHandler(event) {
    if (this.flickity && typeof this.flickity.select === 'function') {
      const index = parseInt(event.target.dataset.blockIndex);
      this.flickity.select(index);
    }
  }

  onFocusHandler(index) {
    this.blocks.forEach((block) => {
      block.classList.remove('focus');

      if (parseInt(block.dataset.blockIndex) === index) {
        block.classList.add('focus');
      }
    });
  }

  initSlider() {
    this.flickity = new Flickity(this.products, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      fade: true,
      setGallerySize: true,
      on: {
        ready: () => {
          this.onFocusHandler(0);
        },
        change: (index) => {
          this.onFocusHandler(index);
        }
      }    
    });
  }
}
customElements.define('shop-the-look', ShopTheLook);

class SelectWrapper extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });

    this.select = this.querySelector('select');
    if (this.select) {
      this.select.addEventListener('change', this.handleSelectChange.bind(this));
    }
  }

  init() {
    const style = window.getComputedStyle(this.select);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement('span');
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = 'hidden';
    text.style.position = 'absolute';
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;
    
    this.style.setProperty('--width', `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define('select-wrapper', SelectWrapper);

class ImageComparison extends HTMLElement {
  constructor() {
    super();

    this.active = false;
    this.button = this.querySelector('button');
    this.horizontal = this.dataset.layout === 'horizontal';
    this.bodyStyleOverflowY = document.body.style.overflowY;
    this.init();

    theme.initWhenVisible({
      element: this.querySelector('.image-comparison__animate'),
      callback: this.animate.bind(this),
      threshold: 0
    });
  }

  animate() {
    this.setAttribute('animate', '');
    this.classList.add('animating');
    setTimeout(() => {
      this.classList.remove('animating');
    }, 1e3);
  }

  init() {
    this.button.addEventListener('touchstart', this.startHandler.bind(this));
    document.body.addEventListener('touchend', this.endHandler.bind(this));
    document.body.addEventListener('touchmove', this.onHandler.bind(this));
    
    this.button.addEventListener('mousedown', this.startHandler.bind(this));
    document.body.addEventListener('mouseup', this.endHandler.bind(this));
    document.body.addEventListener('mousemove', this.onHandler.bind(this));
  }

  startHandler() {
    if(window.innerWidth <= 750) {
      document.body.style.overflowY = 'hidden';
    }

    this.active = true;
    this.classList.add('scrolling');
  }

  endHandler() {
    this.active = false;
    this.classList.remove('scrolling');
    document.body.style.overflowY = this.bodyStyleOverflowY;
  }

  onHandler(e) {
    if (!this.active) return;
    
    const event = (e.touches && e.touches[0]) || e;
    const x = this.horizontal
                ? event.pageX - this.offsetLeft
                : event.pageY - this.offsetTop;

    this.scrollIt(x);
  }

  scrollIt(x) {
    const distance = this.horizontal ? this.clientWidth : this.clientHeight;
    
    const max = distance - 20;
    const min = 20;
    const mouseX = Math.max(min, (Math.min(x, max)));
    const mousePercent = (mouseX * 100) / distance;
    this.style.setProperty('--percent', mousePercent + '%');
  }
}
customElements.define('image-comparison', ImageComparison);

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };

    this.promotion = this.querySelector('.promotion');

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector('.media-wrapper');
        if (imageWrapper) {
          imageWrapper.classList.remove('loading');
        }
      }

      const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, {rootMargin: '0px 0px 50px 0px'});

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);

class AccordionTab extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.accordion__content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.applyResponsiveDefaultState();

    if (this.hasAttribute('data-desktop-static')) {
      this.desktopStaticMql = window.matchMedia(theme.config.mediaQueryProductDesktop);
      const updateStaticState = () => {
        if (this.desktopStaticMql.matches) {
          if (this.animation) this.animation.cancel();
          this.details.open = true;
          this.details.style.height = this.details.style.overflow = '';
          this.summary.setAttribute('role', 'button');
          this.summary.setAttribute('aria-disabled', 'true');
          this.summary.setAttribute('tabindex', '-1');
          this.summary.setAttribute('aria-expanded', 'true');
        } else {
          this.summary.setAttribute('role', 'button');
          this.summary.removeAttribute('aria-level');
          this.summary.removeAttribute('aria-disabled');
          this.summary.setAttribute('tabindex', '0');
          this.summary.setAttribute('aria-expanded', this.details.open);
        }
      };
      updateStaticState();
      this.desktopStaticMql.addEventListener('change', updateStaticState);
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  applyResponsiveDefaultState() {
    if (!this.details || !this.details.hasAttribute('data-mobile-collapsed')) return;

    this.mobileCollapseMql = this.mobileCollapseMql || window.matchMedia(theme.config.mediaQuerySmall);

    const updateDefaultState = () => {
      this.details.style.height = this.details.style.overflow = '';
      this.details.open = !this.mobileCollapseMql.matches;
    };

    updateDefaultState();

    if (this.mobileCollapseMql.addEventListener) {
      this.mobileCollapseMql.addEventListener('change', updateDefaultState);
    } else {
      this.mobileCollapseMql.addListener(updateDefaultState);
    }
  }

  init() {
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();

    if (this.desktopStaticMql?.matches) return;

    this.details.style.overflow = 'hidden';
    if (this.isClosing || !this.details.open) {
      this.open();
    }
    else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    
    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop)}px`;
    
    if (this.animation) {
      this.animation.cancel();
    }
    
    this.animation = this.details.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 250,
      easing: 'ease'
    });
    
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop) + this.content.offsetHeight}px`;
    
    if (this.animation) {
      this.animation.cancel();
    }
    
    this.animation = this.details.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = this.details.style.overflow = '';
  }
}
customElements.define('accordion-tab', AccordionTab);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class HeaderMenuToggle extends HTMLElement {
  constructor() {
    super();
    
    this.header = document.querySelector('.shopify-section-header');
    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.header.classList.toggle('shopify-section-header-menu-open');
  }
}
customElements.define('header-menu-toggle', HeaderMenuToggle);

class OptionTable extends HTMLElement {
  constructor() {
    super();

    this.config = {
    };

    this.imageOptionRows = this.querySelectorAll(".ot--images .ot--option-row");
    this.dataOptionRows = this.querySelectorAll(".ot--data .ot--option-row");

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    const optionTable = this;

    this.imageOptionRows.forEach((imageOptionRow) => {
      imageOptionRow.addEventListener("mouseenter", function () {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "0.3";
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.zIndex = "initial";
        });

        this.style.opacity = "1";
        this.style.zIndex = "3";

        var imageRowId = this.id;
        var dataRowId = imageRowId.replace("imageRow", "dataRow");
        var activeDataRow = optionTable.querySelector(`#${dataRowId}`);
        activeDataRow.classList.add("active");

        optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`).forEach(el => {
          el.classList.remove('active');
        });
        var activeDataRowValues = activeDataRow.querySelectorAll(`:scope div:not(.is-header)`);
        activeDataRowValues.forEach((activeDataRowValue, i) => {
          if (activeDataRowValue.querySelectorAll(`:scope svg.checkmark`).length > 0) {
            const header = optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`)[i];

            if (header) {
              header.classList.add('active');
            }
          }
        });
      });
      imageOptionRow.addEventListener("mouseleave", function () {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "1";
        });
        optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`).forEach(el => {
          el.classList.remove('active');
        });
      });
    });

    this.dataOptionRows.forEach((dataOptionRow) => {
      dataOptionRow.addEventListener("mouseenter", function () {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        this.classList.add("active");
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "0.3";
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.zIndex = "initial";
        });

        var dataRowId = this.id;
        var imageRowId = dataRowId.replace("dataRow", "imageRow");
        optionTable.querySelector(`#${imageRowId}`).style.opacity = "1";
        optionTable.querySelector(`#${imageRowId}`).style.zIndex = "3";
      });
      dataOptionRow.addEventListener("mouseleave", function () {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "1";
        });
        optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`).forEach(el => {
          el.classList.remove('active');
        })
      });
    });
  }
}
customElements.define('option-table', OptionTable);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);

    if (this.classList.contains('on-header')) {
      document.body.classList.remove('localization--open');
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    // this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    // this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

    if (this.classList.contains('on-header')) {
      document.body.classList.toggle('localization--open');
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);
